/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const cancelCrdrMaster = /* GraphQL */ `
  mutation CancelCrdrMaster(
    $updateCrDrNoteMasterInput: UpdateCrDrNoteMasterInput
  ) {
    cancelCrdrMaster(updateCrDrNoteMasterInput: $updateCrDrNoteMasterInput) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      RelatedCrDrNoteTCSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        __typename
      }
      RelatedCrDrNoteTDSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteDispatch {
        CrDrNoteID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      OriginalInvoiceNumber
      TotalGST
      TotalGSTCess
      TotalTaxableAmount
      TotalAdjustments
      Comments
      AccountID
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      PaymentStatus
      __typename
    }
  }
`;
export const createEmailSettings = /* GraphQL */ `
  mutation CreateEmailSettings($emailSettingsInput: EmailSettingsInput) {
    createEmailSettings(emailSettingsInput: $emailSettingsInput) {
      Email
      TemplateID
      EmailBody
      SMTP_PORT
      SMTP_HOSTNAME
      UserName
      Password
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const createPaymentSettings = /* GraphQL */ `
  mutation CreatePaymentSettings($paymentSettingsInput: PaymentSettingsInput) {
    createPaymentSettings(paymentSettingsInput: $paymentSettingsInput) {
      Enable_ItemWiseEntry
      Enable_CreditPeriod
      Enable_CreditLimit
      Enable_AutoPayReminder
      Enable_AutoReminderDays
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteInvoiceDenominations = /* GraphQL */ `
  mutation DeleteInvoiceDenominations($InvoiceID: Int) {
    deleteInvoiceDenominations(InvoiceID: $InvoiceID) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const testingInsertData = /* GraphQL */ `
  mutation TestingInsertData($testingDataInput: TestingDataInput!) {
    testingInsertData(testingDataInput: $testingDataInput) {
      name
      country
      mobile
      city
      state
      address
      __typename
    }
  }
`;
export const deleteAddressEntity = /* GraphQL */ `
  mutation DeleteAddressEntity($ID: Int!) {
    deleteAddressEntity(ID: $ID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const createAddressEntity = /* GraphQL */ `
  mutation CreateAddressEntity(
    $createAddressEntityInput: CreateAddressEntityInput!
  ) {
    createAddressEntity(createAddressEntityInput: $createAddressEntityInput) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const createPartyAddressEntity = /* GraphQL */ `
  mutation CreatePartyAddressEntity(
    $createPartyAddressEntityInput: CreatePartyAddressEntityInput!
  ) {
    createPartyAddressEntity(
      createPartyAddressEntityInput: $createPartyAddressEntityInput
    ) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateAddressEntity = /* GraphQL */ `
  mutation UpdateAddressEntity(
    $updateAddressEntityInput: UpdateAddressEntityInput!
  ) {
    updateAddressEntity(updateAddressEntityInput: $updateAddressEntityInput) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const updatePartyAddressEntity = /* GraphQL */ `
  mutation UpdatePartyAddressEntity(
    $updatePartyAddressEntityInput: UpdatePartyAddressEntityInput!
  ) {
    updatePartyAddressEntity(
      updatePartyAddressEntityInput: $updatePartyAddressEntityInput
    ) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteCodeTranslation = /* GraphQL */ `
  mutation DeleteCodeTranslation($ID: Int!) {
    deleteCodeTranslation(ID: $ID) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      StateCode
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const createCodeTranslation = /* GraphQL */ `
  mutation CreateCodeTranslation(
    $createCodeTranslationInput: CreateCodeTranslationInput!
  ) {
    createCodeTranslation(
      createCodeTranslationInput: $createCodeTranslationInput
    ) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      StateCode
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const updateCodeTranslation = /* GraphQL */ `
  mutation UpdateCodeTranslation(
    $updateCodeTranslationInput: UpdateCodeTranslationInput!
  ) {
    updateCodeTranslation(
      updateCodeTranslationInput: $updateCodeTranslationInput
    ) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      StateCode
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const deleteCompanyCodeTranslation = /* GraphQL */ `
  mutation DeleteCompanyCodeTranslation($ID: Int!) {
    deleteCompanyCodeTranslation(ID: $ID) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const createCompanyCodeTranslation = /* GraphQL */ `
  mutation CreateCompanyCodeTranslation(
    $createCompanyCodeTranslationInput: CreateCompanyCodeTranslationInput!
  ) {
    createCompanyCodeTranslation(
      createCompanyCodeTranslationInput: $createCompanyCodeTranslationInput
    ) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const updateCompanyCodeTranslation = /* GraphQL */ `
  mutation UpdateCompanyCodeTranslation(
    $updateCompanyCodeTranslationInput: UpdateCompanyCodeTranslationInput!
  ) {
    updateCompanyCodeTranslation(
      updateCompanyCodeTranslationInput: $updateCompanyCodeTranslationInput
    ) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany($CompanyID: Int!) {
    deleteCompany(CompanyID: $CompanyID) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany($createCompanyInput: CreateCompanyInput!) {
    createCompany(createCompanyInput: $createCompanyInput) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const createCompanyFY = /* GraphQL */ `
  mutation CreateCompanyFY($createCompanyFYInput: CreateCompanyFYInput!) {
    createCompanyFY(createCompanyFYInput: $createCompanyFYInput) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const createCompanyFYv2 = /* GraphQL */ `
  mutation CreateCompanyFYv2($createCompanyFYInput: CreateCompanyFYInputv2!) {
    createCompanyFYv2(createCompanyFYInput: $createCompanyFYInput) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany($updateCompanyInput: UpdateCompanyInput!) {
    updateCompany(updateCompanyInput: $updateCompanyInput) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        DeletionTime
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;
export const deleteCompanyBranch = /* GraphQL */ `
  mutation DeleteCompanyBranch($ID: Int!) {
    deleteCompanyBranch(ID: $ID) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      BranchName
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCompanyBranch = /* GraphQL */ `
  mutation CreateCompanyBranch(
    $createCompanyBranchInput: CreateCompanyBranchInput!
  ) {
    createCompanyBranch(createCompanyBranchInput: $createCompanyBranchInput) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      BranchName
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateCompanyBranch = /* GraphQL */ `
  mutation UpdateCompanyBranch(
    $updateCompanyBranchInput: UpdateCompanyBranchInput!
  ) {
    updateCompanyBranch(updateCompanyBranchInput: $updateCompanyBranchInput) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      BranchName
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteCompanyBranchRolePermissions = /* GraphQL */ `
  mutation DeleteCompanyBranchRolePermissions($ID: Int!) {
    deleteCompanyBranchRolePermissions(ID: $ID) {
      ID
      RoleID
      CompanyID
      CompanyBranchID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCompanyBranchRolePermissions = /* GraphQL */ `
  mutation CreateCompanyBranchRolePermissions(
    $createCompanyBranchRolePermissionsInput: CreateCompanyBranchRolePermissionsInput!
  ) {
    createCompanyBranchRolePermissions(
      createCompanyBranchRolePermissionsInput: $createCompanyBranchRolePermissionsInput
    ) {
      ID
      RoleID
      CompanyID
      CompanyBranchID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateCompanyBranchRolePermissions = /* GraphQL */ `
  mutation UpdateCompanyBranchRolePermissions(
    $updateCompanyBranchRolePermissionsInput: UpdateCompanyBranchRolePermissionsInput!
  ) {
    updateCompanyBranchRolePermissions(
      updateCompanyBranchRolePermissionsInput: $updateCompanyBranchRolePermissionsInput
    ) {
      ID
      RoleID
      CompanyID
      CompanyBranchID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteCompanyBranchUserRoles = /* GraphQL */ `
  mutation DeleteCompanyBranchUserRoles($ID: Int!) {
    deleteCompanyBranchUserRoles(ID: $ID) {
      ID
      CompanyID
      CompanyBranchID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const createCompanyBranchUserRoles = /* GraphQL */ `
  mutation CreateCompanyBranchUserRoles(
    $createCompanyBranchUserRolesInput: CreateCompanyBranchUserRolesInput!
  ) {
    createCompanyBranchUserRoles(
      createCompanyBranchUserRolesInput: $createCompanyBranchUserRolesInput
    ) {
      ID
      CompanyID
      CompanyBranchID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const updateCompanyBranchUserRoles = /* GraphQL */ `
  mutation UpdateCompanyBranchUserRoles(
    $updateCompanyBranchUserRolesInput: UpdateCompanyBranchUserRolesInput!
  ) {
    updateCompanyBranchUserRoles(
      updateCompanyBranchUserRolesInput: $updateCompanyBranchUserRolesInput
    ) {
      ID
      CompanyID
      CompanyBranchID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const deleteCompanyEntity = /* GraphQL */ `
  mutation DeleteCompanyEntity($ID: Int!) {
    deleteCompanyEntity(ID: $ID) {
      ID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LegalName
      GSTIN
      FinancialYearCode
      CompanyEntityType
      StartDate
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCompanyEntity = /* GraphQL */ `
  mutation CreateCompanyEntity(
    $createCompanyEntityInput: CreateCompanyEntityInput!
  ) {
    createCompanyEntity(createCompanyEntityInput: $createCompanyEntityInput) {
      ID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LegalName
      GSTIN
      FinancialYearCode
      CompanyEntityType
      StartDate
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateCompanyEntity = /* GraphQL */ `
  mutation UpdateCompanyEntity(
    $updateCompanyEntityInput: UpdateCompanyEntityInput!
  ) {
    updateCompanyEntity(updateCompanyEntityInput: $updateCompanyEntityInput) {
      ID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      LegalName
      GSTIN
      FinancialYearCode
      CompanyEntityType
      StartDate
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteCompanyRolePermissions = /* GraphQL */ `
  mutation DeleteCompanyRolePermissions($ID: Int!) {
    deleteCompanyRolePermissions(ID: $ID) {
      ID
      RoleID
      CompanyID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCompanyRolePermissions = /* GraphQL */ `
  mutation CreateCompanyRolePermissions(
    $createCompanyRolePermissionsInput: CreateCompanyRolePermissionsInput!
  ) {
    createCompanyRolePermissions(
      createCompanyRolePermissionsInput: $createCompanyRolePermissionsInput
    ) {
      ID
      RoleID
      CompanyID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateCompanyRolePermissions = /* GraphQL */ `
  mutation UpdateCompanyRolePermissions(
    $updateCompanyRolePermissionsInput: UpdateCompanyRolePermissionsInput!
  ) {
    updateCompanyRolePermissions(
      updateCompanyRolePermissionsInput: $updateCompanyRolePermissionsInput
    ) {
      ID
      RoleID
      CompanyID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteCompanyRoles = /* GraphQL */ `
  mutation DeleteCompanyRoles($ID: Int!) {
    deleteCompanyRoles(ID: $ID) {
      ID
      RoleID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCompanyRoles = /* GraphQL */ `
  mutation CreateCompanyRoles(
    $createCompanyRolesInput: CreateCompanyRolesInput!
  ) {
    createCompanyRoles(createCompanyRolesInput: $createCompanyRolesInput) {
      ID
      RoleID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateCompanyRoles = /* GraphQL */ `
  mutation UpdateCompanyRoles(
    $updateCompanyRolesInput: UpdateCompanyRolesInput!
  ) {
    updateCompanyRoles(updateCompanyRolesInput: $updateCompanyRolesInput) {
      ID
      RoleID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteCompanyUserRoles = /* GraphQL */ `
  mutation DeleteCompanyUserRoles($ID: Int!) {
    deleteCompanyUserRoles(ID: $ID) {
      ID
      CompanyID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const createCompanyUserRoles = /* GraphQL */ `
  mutation CreateCompanyUserRoles(
    $createCompanyUserRolesInput: CreateCompanyUserRolesInput!
  ) {
    createCompanyUserRoles(
      createCompanyUserRolesInput: $createCompanyUserRolesInput
    ) {
      ID
      CompanyID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const updateCompanyUserRoles = /* GraphQL */ `
  mutation UpdateCompanyUserRoles(
    $updateCompanyUserRolesInput: UpdateCompanyUserRolesInput!
  ) {
    updateCompanyUserRoles(
      updateCompanyUserRolesInput: $updateCompanyUserRolesInput
    ) {
      ID
      CompanyID
      UserID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleID
      __typename
    }
  }
`;
export const deleteEmailContacts = /* GraphQL */ `
  mutation DeleteEmailContacts($ID: Int!) {
    deleteEmailContacts(ID: $ID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      EmailAddress
      VerifiedDateTime
      PromotionsSignup
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const createEmailContacts = /* GraphQL */ `
  mutation CreateEmailContacts(
    $createEmailContactsInput: CreateEmailContactsInput!
  ) {
    createEmailContacts(createEmailContactsInput: $createEmailContactsInput) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      EmailAddress
      VerifiedDateTime
      PromotionsSignup
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateEmailContacts = /* GraphQL */ `
  mutation UpdateEmailContacts(
    $updateEmailContactsInput: UpdateEmailContactsInput!
  ) {
    updateEmailContacts(updateEmailContactsInput: $updateEmailContactsInput) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      EmailAddress
      VerifiedDateTime
      PromotionsSignup
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const deletePermissions = /* GraphQL */ `
  mutation DeletePermissions($ID: Int!) {
    deletePermissions(ID: $ID) {
      ID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionName
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPermissions = /* GraphQL */ `
  mutation CreatePermissions($createPermissionsInput: CreatePermissionsInput!) {
    createPermissions(createPermissionsInput: $createPermissionsInput) {
      ID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionName
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePermissions = /* GraphQL */ `
  mutation UpdatePermissions($updatePermissionsInput: UpdatePermissionsInput!) {
    updatePermissions(updatePermissionsInput: $updatePermissionsInput) {
      ID
      PermissionID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionName
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deletePhoneContacts = /* GraphQL */ `
  mutation DeletePhoneContacts($ID: Int!) {
    deletePhoneContacts(ID: $ID) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      CountryCode
      PhoneNumber
      VerifiedDateTime
      PromotionsSignup
      SMSAllowed
      CallAllowed
      WhatsappAllowed
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPhoneContacts = /* GraphQL */ `
  mutation CreatePhoneContacts(
    $createPhoneContactsInput: CreatePhoneContactsInput!
  ) {
    createPhoneContacts(createPhoneContactsInput: $createPhoneContactsInput) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      CountryCode
      PhoneNumber
      VerifiedDateTime
      PromotionsSignup
      SMSAllowed
      CallAllowed
      WhatsappAllowed
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePhoneContacts = /* GraphQL */ `
  mutation UpdatePhoneContacts(
    $updatePhoneContactsInput: UpdatePhoneContactsInput!
  ) {
    updatePhoneContacts(updatePhoneContactsInput: $updatePhoneContactsInput) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      CountryCode
      PhoneNumber
      VerifiedDateTime
      PromotionsSignup
      SMSAllowed
      CallAllowed
      WhatsappAllowed
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteRolePermissions = /* GraphQL */ `
  mutation DeleteRolePermissions($ID: Int!) {
    deleteRolePermissions(ID: $ID) {
      ID
      PermissionID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createRolePermissions = /* GraphQL */ `
  mutation CreateRolePermissions(
    $createRolePermissionsInput: CreateRolePermissionsInput!
  ) {
    createRolePermissions(
      createRolePermissionsInput: $createRolePermissionsInput
    ) {
      ID
      PermissionID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateRolePermissions = /* GraphQL */ `
  mutation UpdateRolePermissions(
    $updateRolePermissionsInput: UpdateRolePermissionsInput!
  ) {
    updateRolePermissions(
      updateRolePermissionsInput: $updateRolePermissionsInput
    ) {
      ID
      PermissionID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      PermissionValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteRoles = /* GraphQL */ `
  mutation DeleteRoles($ID: Int!) {
    deleteRoles(ID: $ID) {
      ID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleName
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createRoles = /* GraphQL */ `
  mutation CreateRoles($createRolesInput: CreateRolesInput!) {
    createRoles(createRolesInput: $createRolesInput) {
      ID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleName
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateRoles = /* GraphQL */ `
  mutation UpdateRoles($updateRolesInput: UpdateRolesInput!) {
    updateRoles(updateRolesInput: $updateRolesInput) {
      ID
      RoleID
      EnteredTimeStamp
      ExpiredTimeStamp
      RoleName
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteUserInfo = /* GraphQL */ `
  mutation DeleteUserInfo($ID: Int!) {
    deleteUserInfo(ID: $ID) {
      id
      userid
      enteredtimestamp
      expiredtimestamp
      firstname
      middlename
      lastname
      email
      phonenumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const createUserInfo = /* GraphQL */ `
  mutation CreateUserInfo($createUserInfoInput: CreateUserInfoInput!) {
    createUserInfo(createUserInfoInput: $createUserInfoInput) {
      id
      userid
      enteredtimestamp
      expiredtimestamp
      firstname
      middlename
      lastname
      email
      phonenumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const updateUserInfo = /* GraphQL */ `
  mutation UpdateUserInfo($updateUserInfoInput: UpdateUserInfoInput!) {
    updateUserInfo(updateUserInfoInput: $updateUserInfoInput) {
      id
      userid
      enteredtimestamp
      expiredtimestamp
      firstname
      middlename
      lastname
      email
      phonenumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const deleteItemmaster = /* GraphQL */ `
  mutation DeleteItemmaster($ItemID: Int!) {
    deleteItemmaster(ItemID: $ItemID) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      relatedItemAmountDetails {
        ItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        Amount
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTCompensationValue
        GSTRATE
        StatusCode
        StatusMessage
        LastUpdatedBy
        DiscountType
        DiscountValue
        InvoiceType
        PriceType
        IsActive
        IsDefault
        __typename
      }
      relatedItemGstDetails {
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        HSNID
        GSTCessType
        GSTCompensationValue
        EffectiveDate
        ExpiredDate
        GSTCessValue
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedItemImages {
        AttachmentID
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ImageName
        ImageURL
        DocumentName
        Type
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      SerialNumber
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Description
      __typename
    }
  }
`;
export const createItemmaster = /* GraphQL */ `
  mutation CreateItemmaster($createItemmasterInput: CreateItemmasterInput!) {
    createItemmaster(createItemmasterInput: $createItemmasterInput) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      relatedItemAmountDetails {
        ItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        Amount
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTCompensationValue
        GSTRATE
        StatusCode
        StatusMessage
        LastUpdatedBy
        DiscountType
        DiscountValue
        InvoiceType
        PriceType
        IsActive
        IsDefault
        __typename
      }
      relatedItemGstDetails {
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        HSNID
        GSTCessType
        GSTCompensationValue
        EffectiveDate
        ExpiredDate
        GSTCessValue
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedItemImages {
        AttachmentID
        ItemID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ImageName
        ImageURL
        DocumentName
        Type
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      SerialNumber
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Description
      __typename
    }
  }
`;
export const updateItemmaster = /* GraphQL */ `
  mutation UpdateItemmaster($updateItemmasterInput: UpdateItemmasterInput!) {
    updateItemmaster(updateItemmasterInput: $updateItemmasterInput) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      LastUpdatedBy
      ItemAmountEnteredTimeStamp
      ItemAmountExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      ItemAmountHSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      DiscountType
      DiscountValue
      ImageName
      ImageURL
      SerialNumber
      IsDefault
      InvoiceType
      DefaultSellingPrice
      DefaultPurchasePrice
      CodeText
      ItemCategory
      SellingGSTCompensationType
      PurchaseGSTCompensationType
      SellingGSTCompensationValue
      PurchaseGSTCompensationValue
      SellingGSTRATE
      PurchaseGSTRATE
      SellingDiscountType
      PurchaseDiscountType
      SellingDiscountValue
      PurchaseDiscountValue
      Description
      __typename
    }
  }
`;
export const createItemCategorymaster = /* GraphQL */ `
  mutation CreateItemCategorymaster(
    $createItemCategorymasterInput: CreateItemCategorymasterInput!
  ) {
    createItemCategorymaster(
      createItemCategorymasterInput: $createItemCategorymasterInput
    ) {
      ItemCategoryID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Category
      ItemCategoryGroupID
      MainCategory
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateItemCategorymaster = /* GraphQL */ `
  mutation UpdateItemCategorymaster(
    $updateItemCategorymasterInput: UpdateItemCategorymasterInput!
  ) {
    updateItemCategorymaster(
      updateItemCategorymasterInput: $updateItemCategorymasterInput
    ) {
      ItemCategoryID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Category
      ItemCategoryGroupID
      MainCategory
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteItemCategorymaster = /* GraphQL */ `
  mutation DeleteItemCategorymaster($ItemCategoryID: Int!) {
    deleteItemCategorymaster(ItemCategoryID: $ItemCategoryID) {
      ItemCategoryID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Category
      ItemCategoryGroupID
      MainCategory
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const createItemAmountDetails = /* GraphQL */ `
  mutation CreateItemAmountDetails(
    $createItemAmountDetailsInput: CreateItemAmountDetailsInput!
  ) {
    createItemAmountDetails(
      createItemAmountDetailsInput: $createItemAmountDetailsInput
    ) {
      ItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      StatusCode
      StatusMessage
      LastUpdatedBy
      DiscountType
      DiscountValue
      InvoiceType
      PriceType
      IsActive
      IsDefault
      __typename
    }
  }
`;
export const updateItemAmountDetails = /* GraphQL */ `
  mutation UpdateItemAmountDetails(
    $updateItemAmountDetailsInput: UpdateItemAmountDetailsInput!
  ) {
    updateItemAmountDetails(
      updateItemAmountDetailsInput: $updateItemAmountDetailsInput
    ) {
      ItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      StatusCode
      StatusMessage
      LastUpdatedBy
      DiscountType
      DiscountValue
      InvoiceType
      PriceType
      IsActive
      IsDefault
      __typename
    }
  }
`;
export const deleteItemAmountDetails = /* GraphQL */ `
  mutation DeleteItemAmountDetails(
    $itemAmountDelReqInput: ItemAmountDelReqInput!
  ) {
    deleteItemAmountDetails(itemAmountDelReqInput: $itemAmountDelReqInput) {
      ItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      StatusCode
      StatusMessage
      LastUpdatedBy
      DiscountType
      DiscountValue
      InvoiceType
      PriceType
      IsActive
      IsDefault
      __typename
    }
  }
`;
export const deleteItemAmountDetailsv2 = /* GraphQL */ `
  mutation DeleteItemAmountDetailsv2(
    $itemAmountDelReqInput: ItemAmountDelReqInputv2!
  ) {
    deleteItemAmountDetailsv2(itemAmountDelReqInput: $itemAmountDelReqInput) {
      ItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      StatusCode
      StatusMessage
      LastUpdatedBy
      DiscountType
      DiscountValue
      InvoiceType
      PriceType
      IsActive
      IsDefault
      __typename
    }
  }
`;
export const createItemGstDetails = /* GraphQL */ `
  mutation CreateItemGstDetails(
    $createItemGstDetailsInput: CreateItemGstDetailsInput!
  ) {
    createItemGstDetails(
      createItemGstDetailsInput: $createItemGstDetailsInput
    ) {
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      HSNID
      GSTCessType
      GSTCompensationValue
      EffectiveDate
      ExpiredDate
      GSTCessValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateItemGstDetails = /* GraphQL */ `
  mutation UpdateItemGstDetails(
    $updateItemGstDetailsInput: UpdateItemGstDetailsInput!
  ) {
    updateItemGstDetails(
      updateItemGstDetailsInput: $updateItemGstDetailsInput
    ) {
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      HSNID
      GSTCessType
      GSTCompensationValue
      EffectiveDate
      ExpiredDate
      GSTCessValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteItemGstDetails = /* GraphQL */ `
  mutation DeleteItemGstDetails($itemGstDelReqInput: ItemGstDelReqInput!) {
    deleteItemGstDetails(itemGstDelReqInput: $itemGstDelReqInput) {
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      HSNID
      GSTCessType
      GSTCompensationValue
      EffectiveDate
      ExpiredDate
      GSTCessValue
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCompanyDetails = /* GraphQL */ `
  mutation CreateCompanyDetails(
    $createCompanyDetailsInput: CreateCompanyDetailsInput!
  ) {
    createCompanyDetails(
      createCompanyDetailsInput: $createCompanyDetailsInput
    ) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      CompPercentage
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      EInvoiceConnect
      StatusCode
      StatusMessage
      BusinessType {
        BusinessTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        BusinessType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      IndustryType {
        IndustryTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        IndustryType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      ActiveFlag
      RelatedFinancialYearData {
        FinancialYearID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        StartDate
        EndDate
        StartYear
        EndYear
        Comments
        UserID
        AliasName
        StatusCode
        StatusMessage
        FreezeStatus
        TransferDate
        FreezeDate
        __typename
      }
      DeletionTime
      __typename
    }
  }
`;
export const updateCompanyDetails = /* GraphQL */ `
  mutation UpdateCompanyDetails(
    $updateCompanyDetailsInput: UpdateCompanyDetailsInput!
  ) {
    updateCompanyDetails(
      updateCompanyDetailsInput: $updateCompanyDetailsInput
    ) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      CompPercentage
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      EInvoiceConnect
      StatusCode
      StatusMessage
      BusinessType {
        BusinessTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        BusinessType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      IndustryType {
        IndustryTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        IndustryType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      ActiveFlag
      RelatedFinancialYearData {
        FinancialYearID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        StartDate
        EndDate
        StartYear
        EndYear
        Comments
        UserID
        AliasName
        StatusCode
        StatusMessage
        FreezeStatus
        TransferDate
        FreezeDate
        __typename
      }
      DeletionTime
      __typename
    }
  }
`;
export const updateCompanyDetailsv2 = /* GraphQL */ `
  mutation UpdateCompanyDetailsv2(
    $updateCompanyDetailsInputv2: UpdateCompanyDetailsInputv2!
  ) {
    updateCompanyDetailsv2(
      updateCompanyDetailsInputv2: $updateCompanyDetailsInputv2
    ) {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      CompPercentage
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      EInvoiceConnect
      StatusCode
      StatusMessage
      BusinessType {
        BusinessTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        BusinessType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      IndustryType {
        IndustryTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        IndustryType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      ActiveFlag
      RelatedFinancialYearData {
        FinancialYearID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        StartDate
        EndDate
        StartYear
        EndYear
        Comments
        UserID
        AliasName
        StatusCode
        StatusMessage
        FreezeStatus
        TransferDate
        FreezeDate
        __typename
      }
      DeletionTime
      __typename
    }
  }
`;
export const updateCompanyProfileDetails = /* GraphQL */ `
  mutation UpdateCompanyProfileDetails(
    $updateCompanyProfileDetailsInput: UpdateCompanyProfileDetailsInput!
  ) {
    updateCompanyProfileDetails(
      updateCompanyProfileDetailsInput: $updateCompanyProfileDetailsInput
    ) {
      CompanyID
      WebsiteURL
      CurrencyCD
      CompanyShort
      CompanyLegalName
      CompanyLogoUrl
      EmailAddress
      PhoneNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteCompanyDetails = /* GraphQL */ `
  mutation DeleteCompanyDetails {
    deleteCompanyDetails {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      CompPercentage
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      EInvoiceConnect
      StatusCode
      StatusMessage
      BusinessType {
        BusinessTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        BusinessType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      IndustryType {
        IndustryTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        IndustryType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      ActiveFlag
      RelatedFinancialYearData {
        FinancialYearID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        StartDate
        EndDate
        StartYear
        EndYear
        Comments
        UserID
        AliasName
        StatusCode
        StatusMessage
        FreezeStatus
        TransferDate
        FreezeDate
        __typename
      }
      DeletionTime
      __typename
    }
  }
`;
export const createPartyMaster = /* GraphQL */ `
  mutation CreatePartyMaster($createPartyMasterInput: CreatePartyMasterInput!) {
    createPartyMaster(createPartyMasterInput: $createPartyMasterInput) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const updatePartyMaster = /* GraphQL */ `
  mutation UpdatePartyMaster($updatePartyMasterInput: UpdatePartyMasterInput!) {
    updatePartyMaster(updatePartyMasterInput: $updatePartyMasterInput) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const deletePartyMaster = /* GraphQL */ `
  mutation DeletePartyMaster($PartyID: Int!) {
    deletePartyMaster(PartyID: $PartyID) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const createPartyGSTDetails = /* GraphQL */ `
  mutation CreatePartyGSTDetails(
    $createPartyGSTDetailsInput: CreatePartyGSTDetailsInput!
  ) {
    createPartyGSTDetails(
      createPartyGSTDetailsInput: $createPartyGSTDetailsInput
    ) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      PANNummber
      GSTIN
      PartyAddressID
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePartyGSTDetails = /* GraphQL */ `
  mutation UpdatePartyGSTDetails(
    $updatePartyGSTDetailsInput: UpdatePartyGSTDetailsInput!
  ) {
    updatePartyGSTDetails(
      updatePartyGSTDetailsInput: $updatePartyGSTDetailsInput
    ) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      PANNummber
      GSTIN
      PartyAddressID
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deletePartyGSTDetails = /* GraphQL */ `
  mutation DeletePartyGSTDetails($PartyID: Int!) {
    deletePartyGSTDetails(PartyID: $PartyID) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      PANNummber
      GSTIN
      PartyAddressID
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPartyCreditDetails = /* GraphQL */ `
  mutation CreatePartyCreditDetails(
    $createPartyCreditDetailsInput: CreatePartyCreditDetailsInput!
  ) {
    createPartyCreditDetails(
      createPartyCreditDetailsInput: $createPartyCreditDetailsInput
    ) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CreditPeriodDuration
      BillingCurrency
      CreditLimitCd
      CreditLimitAmount
      BillWiseFlag
      Notes
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePartyCreditDetails = /* GraphQL */ `
  mutation UpdatePartyCreditDetails(
    $updatePartyCreditDetailsInput: UpdatePartyCreditDetailsInput!
  ) {
    updatePartyCreditDetails(
      updatePartyCreditDetailsInput: $updatePartyCreditDetailsInput
    ) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CreditPeriodDuration
      BillingCurrency
      CreditLimitCd
      CreditLimitAmount
      BillWiseFlag
      Notes
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deletePartyCreditDetails = /* GraphQL */ `
  mutation DeletePartyCreditDetails($PartyID: Int!) {
    deletePartyCreditDetails(PartyID: $PartyID) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CreditPeriodDuration
      BillingCurrency
      CreditLimitCd
      CreditLimitAmount
      BillWiseFlag
      Notes
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPartyContact = /* GraphQL */ `
  mutation CreatePartyContact(
    $createPartyContactInput: CreatePartyContactInput!
  ) {
    createPartyContact(createPartyContactInput: $createPartyContactInput) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ContactTypeName
      ContactDesignationName
      ContactOrder
      Email
      PhoneNumber
      WhatsappNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePartyContact = /* GraphQL */ `
  mutation UpdatePartyContact(
    $updatePartyContactInput: UpdatePartyContactInput!
  ) {
    updatePartyContact(updatePartyContactInput: $updatePartyContactInput) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ContactTypeName
      ContactDesignationName
      ContactOrder
      Email
      PhoneNumber
      WhatsappNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deletePartyContact = /* GraphQL */ `
  mutation DeletePartyContact($PartyID: Int!) {
    deletePartyContact(PartyID: $PartyID) {
      PartyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ContactTypeName
      ContactDesignationName
      ContactOrder
      Email
      PhoneNumber
      WhatsappNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createHSNSACMaster = /* GraphQL */ `
  mutation CreateHSNSACMaster(
    $createHSNSACMasterInput: CreateHSNSACMasterInput!
  ) {
    createHSNSACMaster(createHSNSACMasterInput: $createHSNSACMasterInput) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const updateHSNSACMaster = /* GraphQL */ `
  mutation UpdateHSNSACMaster(
    $updateHSNSACMasterInput: UpdateHSNSACMasterInput!
  ) {
    updateHSNSACMaster(updateHSNSACMasterInput: $updateHSNSACMasterInput) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const deleteHSNSACMaster = /* GraphQL */ `
  mutation DeleteHSNSACMaster($hsnsacDelReqInput: Int!) {
    deleteHSNSACMaster(hsnsacDelReqInput: $hsnsacDelReqInput) {
      HSNSACID
      CodeType
      HSNSACCode
      Description
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      StatusCode
      StatusMessage
      CompanyID
      __typename
    }
  }
`;
export const createInvoiceMaster = /* GraphQL */ `
  mutation CreateInvoiceMaster(
    $createInvoicemasterInput: CreateInvoicemasterInput!
  ) {
    createInvoiceMaster(createInvoicemasterInput: $createInvoicemasterInput) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const updateInvoiceMaster = /* GraphQL */ `
  mutation UpdateInvoiceMaster(
    $updateInvoicemasterInput: UpdateInvoicemasterInput!
  ) {
    updateInvoiceMaster(updateInvoicemasterInput: $updateInvoicemasterInput) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const deleteInvoiceMaster = /* GraphQL */ `
  mutation DeleteInvoiceMaster(
    $InvoiceID: Int!
    $DeleteRemark: String
    $PaymentDeleteFlag: Int
  ) {
    deleteInvoiceMaster(
      InvoiceID: $InvoiceID
      DeleteRemark: $DeleteRemark
      PaymentDeleteFlag: $PaymentDeleteFlag
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const createInvoiceAttachment = /* GraphQL */ `
  mutation CreateInvoiceAttachment(
    $createInvoiceAttachmentInput: CreateInvoiceAttachmentInput!
  ) {
    createInvoiceAttachment(
      createInvoiceAttachmentInput: $createInvoiceAttachmentInput
    ) {
      InvoiceID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const updateInvoiceAttachment = /* GraphQL */ `
  mutation UpdateInvoiceAttachment(
    $updateInvoiceAttachmentInput: UpdateInvoiceAttachmentInput!
  ) {
    updateInvoiceAttachment(
      updateInvoiceAttachmentInput: $updateInvoiceAttachmentInput
    ) {
      InvoiceID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const deleteInvoiceAttachment = /* GraphQL */ `
  mutation DeleteInvoiceAttachment($InvoiceID: Int!) {
    deleteInvoiceAttachment(InvoiceID: $InvoiceID) {
      InvoiceID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createInvoiceLineItems = /* GraphQL */ `
  mutation CreateInvoiceLineItems(
    $createInvoiceLineItemsInput: CreateInvoiceLineItemsInput!
  ) {
    createInvoiceLineItems(
      createInvoiceLineItemsInput: $createInvoiceLineItemsInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      InvoiceLineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      HSNSACCode
      Taxability
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      Unit
      UQC
      SalesAccountName
      SalesAccountID
      __typename
    }
  }
`;
export const createInvoiceLineItemsArray = /* GraphQL */ `
  mutation CreateInvoiceLineItemsArray(
    $createInvoiceLineItemsInputArray: AWSJSON!
    $createInvoiceLineGSTArray: AWSJSON!
  ) {
    createInvoiceLineItemsArray(
      createInvoiceLineItemsInputArray: $createInvoiceLineItemsInputArray
      createInvoiceLineGSTArray: $createInvoiceLineGSTArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createInvoiceLineNonItemsArray = /* GraphQL */ `
  mutation CreateInvoiceLineNonItemsArray(
    $createInvoiceLineNonItemsInputArray: AWSJSON!
    $createInvoiceLineNonGSTArray: AWSJSON!
  ) {
    createInvoiceLineNonItemsArray(
      createInvoiceLineNonItemsInputArray: $createInvoiceLineNonItemsInputArray
      createInvoiceLineNonGSTArray: $createInvoiceLineNonGSTArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCrDrNoteLineItemsArray = /* GraphQL */ `
  mutation CreateCrDrNoteLineItemsArray(
    $createCrDrNoteLineItemsInputArray: AWSJSON!
  ) {
    createCrDrNoteLineItemsArray(
      createCrDrNoteLineItemsInputArray: $createCrDrNoteLineItemsInputArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCrDrNoteLineNonItemsArray = /* GraphQL */ `
  mutation CreateCrDrNoteLineNonItemsArray(
    $createCrDrNoteLineNonItemsInputArray: AWSJSON!
  ) {
    createCrDrNoteLineNonItemsArray(
      createCrDrNoteLineNonItemsInputArray: $createCrDrNoteLineNonItemsInputArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createItemAmountDetailsArray = /* GraphQL */ `
  mutation CreateItemAmountDetailsArray(
    $createItemAmountDetailsInputArray: AWSJSON!
  ) {
    createItemAmountDetailsArray(
      createItemAmountDetailsInputArray: $createItemAmountDetailsInputArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseLineItemsArray = /* GraphQL */ `
  mutation CreatePurchaseLineItemsArray(
    $createPurchaseLineItemsInputArray: AWSJSON!
    $createPurchaseLineGSTArray: AWSJSON!
  ) {
    createPurchaseLineItemsArray(
      createPurchaseLineItemsInputArray: $createPurchaseLineItemsInputArray
      createPurchaseLineGSTArray: $createPurchaseLineGSTArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseLineNonItemsArray = /* GraphQL */ `
  mutation CreatePurchaseLineNonItemsArray(
    $createPurchaseLineNonItemsInputArray: AWSJSON!
    $createPurchaseLineNonGSTArray: AWSJSON!
  ) {
    createPurchaseLineNonItemsArray(
      createPurchaseLineNonItemsInputArray: $createPurchaseLineNonItemsInputArray
      createPurchaseLineNonGSTArray: $createPurchaseLineNonGSTArray
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateInvoiceLineItems = /* GraphQL */ `
  mutation UpdateInvoiceLineItems(
    $updateInvoiceLineItemsInput: UpdateInvoiceLineItemsInput!
  ) {
    updateInvoiceLineItems(
      updateInvoiceLineItemsInput: $updateInvoiceLineItemsInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      InvoiceLineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      HSNSACCode
      Taxability
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      Unit
      UQC
      SalesAccountName
      SalesAccountID
      __typename
    }
  }
`;
export const deleteInvoiceLineItems = /* GraphQL */ `
  mutation DeleteInvoiceLineItems($InvoiceID: Int!, $InvoiceItemID: Int!) {
    deleteInvoiceLineItems(
      InvoiceID: $InvoiceID
      InvoiceItemID: $InvoiceItemID
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      InvoiceLineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      HSNSACCode
      Taxability
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      Unit
      UQC
      SalesAccountName
      SalesAccountID
      __typename
    }
  }
`;
export const createInvoiceDispatch = /* GraphQL */ `
  mutation CreateInvoiceDispatch(
    $createInvoiceDispatchInput: CreateInvoiceDispatchInput!
  ) {
    createInvoiceDispatch(
      createInvoiceDispatchInput: $createInvoiceDispatchInput
    ) {
      InvoiceID
      DispatchID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransportationCD
      VehicleNumber
      DispatchDate
      EWayBillNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateInvoiceDispatch = /* GraphQL */ `
  mutation UpdateInvoiceDispatch(
    $updateInvoiceDispatchInput: UpdateInvoiceDispatchInput!
  ) {
    updateInvoiceDispatch(
      updateInvoiceDispatchInput: $updateInvoiceDispatchInput
    ) {
      InvoiceID
      DispatchID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransportationCD
      VehicleNumber
      DispatchDate
      EWayBillNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateCrDrNoteDispatch = /* GraphQL */ `
  mutation UpdateCrDrNoteDispatch(
    $updateCrDrNoteDispatchInput: UpdateCrDrNoteDispatchInput!
  ) {
    updateCrDrNoteDispatch(
      updateCrDrNoteDispatchInput: $updateCrDrNoteDispatchInput
    ) {
      CrDrNoteID
      DispatchID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransportationCD
      VehicleNumber
      DispatchDate
      EWayBillNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteInvoiceDispatch = /* GraphQL */ `
  mutation DeleteInvoiceDispatch($InvoiceID: Int!) {
    deleteInvoiceDispatch(InvoiceID: $InvoiceID) {
      InvoiceID
      DispatchID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransportationCD
      VehicleNumber
      DispatchDate
      EWayBillNumber
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createInvoiceLineGST = /* GraphQL */ `
  mutation CreateInvoiceLineGST(
    $createInvoiceLineGSTInput: CreateInvoiceLineGSTInput!
  ) {
    createInvoiceLineGST(
      createInvoiceLineGSTInput: $createInvoiceLineGSTInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateInvoiceLineGST = /* GraphQL */ `
  mutation UpdateInvoiceLineGST(
    $updateInvoiceLineGSTInput: UpdateInvoiceLineGSTInput!
  ) {
    updateInvoiceLineGST(
      updateInvoiceLineGSTInput: $updateInvoiceLineGSTInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createInvoiceLineNonGST = /* GraphQL */ `
  mutation CreateInvoiceLineNonGST(
    $createInvoiceLineNonGSTInput: CreateInvoiceLineNonGSTInput!
  ) {
    createInvoiceLineNonGST(
      createInvoiceLineNonGSTInput: $createInvoiceLineNonGSTInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteInvoiceLineGST = /* GraphQL */ `
  mutation DeleteInvoiceLineGST($InvoiceID: Int!, $InvoiceItemID: Int!) {
    deleteInvoiceLineGST(InvoiceID: $InvoiceID, InvoiceItemID: $InvoiceItemID) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createInvoiceLineNonItems = /* GraphQL */ `
  mutation CreateInvoiceLineNonItems(
    $createInvoiceLineNonItemsInput: CreateInvoiceLineNonItemsInput!
  ) {
    createInvoiceLineNonItems(
      createInvoiceLineNonItemsInput: $createInvoiceLineNonItemsInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceLineItemType
      IncomeAccountID
      HSNSACCode
      Taxability
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      IncomeAccountName
      __typename
    }
  }
`;
export const updateInvoiceLineNonItems = /* GraphQL */ `
  mutation UpdateInvoiceLineNonItems(
    $updateInvoiceLineNonItemsInput: UpdateInvoiceLineNonItemsInput!
  ) {
    updateInvoiceLineNonItems(
      updateInvoiceLineNonItemsInput: $updateInvoiceLineNonItemsInput
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceLineItemType
      IncomeAccountID
      HSNSACCode
      Taxability
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      IncomeAccountName
      __typename
    }
  }
`;
export const deleteInvoiceLineNonItems = /* GraphQL */ `
  mutation DeleteInvoiceLineNonItems($InvoiceID: Int!, $InvoiceItemID: Int!) {
    deleteInvoiceLineNonItems(
      InvoiceID: $InvoiceID
      InvoiceItemID: $InvoiceItemID
    ) {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceLineItemType
      IncomeAccountID
      HSNSACCode
      Taxability
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTTypeCD
      GSTAmount
      CessAmount
      IncomeAccountName
      __typename
    }
  }
`;
export const createInvoicePOSDetails = /* GraphQL */ `
  mutation CreateInvoicePOSDetails(
    $createInvoicePOSDetailsInput: CreateInvoicePOSDetailsInput!
  ) {
    createInvoicePOSDetails(
      createInvoicePOSDetailsInput: $createInvoicePOSDetailsInput
    ) {
      POSID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyPOSID
      LastUpdatedBy
      RelatedPOSParty {
        PosPartyID
        CompanyID
        PartyName
        PartyContactNumberID
        LastUpdatedBy
        EnteredTimeStamp
        ExpiredTimeStamp
        RelatedPhoneContacts {
          ID
          ObjectType
          ObjectID
          EnteredTimeStamp
          ExpiredTimeStamp
          CountryCode
          PhoneNumber
          VerifiedDateTime
          PromotionsSignup
          SMSAllowed
          CallAllowed
          WhatsappAllowed
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        __typename
      }
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateInvoicePOSDetails = /* GraphQL */ `
  mutation UpdateInvoicePOSDetails(
    $updateInvoicePOSDetailsInput: UpdateInvoicePOSDetailsInput!
  ) {
    updateInvoicePOSDetails(
      updateInvoicePOSDetailsInput: $updateInvoicePOSDetailsInput
    ) {
      POSID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyPOSID
      LastUpdatedBy
      RelatedPOSParty {
        PosPartyID
        CompanyID
        PartyName
        PartyContactNumberID
        LastUpdatedBy
        EnteredTimeStamp
        ExpiredTimeStamp
        RelatedPhoneContacts {
          ID
          ObjectType
          ObjectID
          EnteredTimeStamp
          ExpiredTimeStamp
          CountryCode
          PhoneNumber
          VerifiedDateTime
          PromotionsSignup
          SMSAllowed
          CallAllowed
          WhatsappAllowed
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        __typename
      }
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteInvoicePOSDetails = /* GraphQL */ `
  mutation DeleteInvoicePOSDetails($InvoiceID: Int!) {
    deleteInvoicePOSDetails(InvoiceID: $InvoiceID) {
      POSID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyPOSID
      LastUpdatedBy
      RelatedPOSParty {
        PosPartyID
        CompanyID
        PartyName
        PartyContactNumberID
        LastUpdatedBy
        EnteredTimeStamp
        ExpiredTimeStamp
        RelatedPhoneContacts {
          ID
          ObjectType
          ObjectID
          EnteredTimeStamp
          ExpiredTimeStamp
          CountryCode
          PhoneNumber
          VerifiedDateTime
          PromotionsSignup
          SMSAllowed
          CallAllowed
          WhatsappAllowed
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        __typename
      }
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createItemImages = /* GraphQL */ `
  mutation CreateItemImages($createItemImagesInput: CreateItemImagesInput!) {
    createItemImages(createItemImagesInput: $createItemImagesInput) {
      AttachmentID
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      DocumentName
      Type
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateItemImages = /* GraphQL */ `
  mutation UpdateItemImages($updateItemImagesInput: UpdateItemImagesInput!) {
    updateItemImages(updateItemImagesInput: $updateItemImagesInput) {
      AttachmentID
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      DocumentName
      Type
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteItemImages = /* GraphQL */ `
  mutation DeleteItemImages($ItemID: Int!) {
    deleteItemImages(ItemID: $ItemID) {
      AttachmentID
      ItemID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      DocumentName
      Type
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPartyImages = /* GraphQL */ `
  mutation CreatePartyImages($createPartyImagesInput: CreatePartyImagesInput!) {
    createPartyImages(createPartyImagesInput: $createPartyImagesInput) {
      AttachmentID
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Type
      DocumentName
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePartyImages = /* GraphQL */ `
  mutation UpdatePartyImages($updatePartyImagesInput: UpdatePartyImagesInput!) {
    updatePartyImages(updatePartyImagesInput: $updatePartyImagesInput) {
      AttachmentID
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Type
      DocumentName
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deletePartyImages = /* GraphQL */ `
  mutation DeletePartyImages($PartyID: Int!) {
    deletePartyImages(PartyID: $PartyID) {
      AttachmentID
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Type
      DocumentName
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseAttachment = /* GraphQL */ `
  mutation CreatePurchaseAttachment(
    $createPurchaseAttachmentInput: CreatePurchaseAttachmentInput!
  ) {
    createPurchaseAttachment(
      createPurchaseAttachmentInput: $createPurchaseAttachmentInput
    ) {
      PurchaseID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const updatePurchaseAttachment = /* GraphQL */ `
  mutation UpdatePurchaseAttachment(
    $updatePurchaseAttachmentInput: UpdatePurchaseAttachmentInput!
  ) {
    updatePurchaseAttachment(
      updatePurchaseAttachmentInput: $updatePurchaseAttachmentInput
    ) {
      PurchaseID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const deletePurchaseAttachment = /* GraphQL */ `
  mutation DeletePurchaseAttachment($PurchaseID: Int!) {
    deletePurchaseAttachment(PurchaseID: $PurchaseID) {
      PurchaseID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createPurchaseLineGST = /* GraphQL */ `
  mutation CreatePurchaseLineGST(
    $createPurchaseLineGSTInput: CreatePurchaseLineGSTInput!
  ) {
    createPurchaseLineGST(
      createPurchaseLineGSTInput: $createPurchaseLineGSTInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      CessAmount
      GSTAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseLineNonGST = /* GraphQL */ `
  mutation CreatePurchaseLineNonGST(
    $createPurchaseLineNonGSTInput: CreatePurchaseLineNonGSTInput!
  ) {
    createPurchaseLineNonGST(
      createPurchaseLineNonGSTInput: $createPurchaseLineNonGSTInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      CessAmount
      GSTAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePurchaseLineGST = /* GraphQL */ `
  mutation UpdatePurchaseLineGST(
    $updatePurchaseLineGSTInput: UpdatePurchaseLineGSTInput!
  ) {
    updatePurchaseLineGST(
      updatePurchaseLineGSTInput: $updatePurchaseLineGSTInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      CessAmount
      GSTAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deletePurchaseLineGST = /* GraphQL */ `
  mutation DeletePurchaseLineGST($PurchaseID: Int!, $PurchaseItemID: Int!) {
    deletePurchaseLineGST(
      PurchaseID: $PurchaseID
      PurchaseItemID: $PurchaseItemID
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      GSTRate
      CessAmount
      GSTAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseLineItems = /* GraphQL */ `
  mutation CreatePurchaseLineItems(
    $createPurchaseLineItemsInput: CreatePurchaseLineItemsInput!
  ) {
    createPurchaseLineItems(
      createPurchaseLineItemsInput: $createPurchaseLineItemsInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemNumber
      ItemID
      PurchaseAccountID
      HSNCode
      ItemQuantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNSACCode
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      Unit
      UQC
      PurchaseAccountName
      __typename
    }
  }
`;
export const updatePurchaseLineItems = /* GraphQL */ `
  mutation UpdatePurchaseLineItems(
    $updatePurchaseLineItemsInput: UpdatePurchaseLineItemsInput!
  ) {
    updatePurchaseLineItems(
      updatePurchaseLineItemsInput: $updatePurchaseLineItemsInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemNumber
      ItemID
      PurchaseAccountID
      HSNCode
      ItemQuantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNSACCode
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      Unit
      UQC
      PurchaseAccountName
      __typename
    }
  }
`;
export const deletePurchaseLineItems = /* GraphQL */ `
  mutation DeletePurchaseLineItems($PurchaseID: Int!, $PurchaseItemID: Int!) {
    deletePurchaseLineItems(
      PurchaseID: $PurchaseID
      PurchaseItemID: $PurchaseItemID
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemNumber
      ItemID
      PurchaseAccountID
      HSNCode
      ItemQuantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedItemMaster {
        ItemID
        ItemCode
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemName
        SalesInvoiceFlag
        PurchaseInvoiceFlag
        ItemCategoryCD
        MeasurementCD
        CurrencyCD
        SalesAccountID
        PurchaseAccountID
        TaxabilityCD
        ReverseChargeFlag
        ItemType
        HSNID
        Is_Active
        StatusCode
        StatusMessage
        relatedItemAmountDetails {
          ItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          Amount
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTCompensationValue
          GSTRATE
          StatusCode
          StatusMessage
          LastUpdatedBy
          DiscountType
          DiscountValue
          InvoiceType
          PriceType
          IsActive
          IsDefault
          __typename
        }
        relatedItemGstDetails {
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          HSNID
          GSTCessType
          GSTCompensationValue
          EffectiveDate
          ExpiredDate
          GSTCessValue
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedItemImages {
          AttachmentID
          ItemID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ImageName
          ImageURL
          DocumentName
          Type
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        SerialNumber
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Description
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      PriceType
      LotID
      HSNSACID
      HSNCodeType
      HSNSACCode
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      Unit
      UQC
      PurchaseAccountName
      __typename
    }
  }
`;
export const createPurchaseMaster = /* GraphQL */ `
  mutation CreatePurchaseMaster(
    $createPurchaseMasterInput: CreatePurchaseMasterInput!
  ) {
    createPurchaseMaster(
      createPurchaseMasterInput: $createPurchaseMasterInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const updatePurchaseMaster = /* GraphQL */ `
  mutation UpdatePurchaseMaster(
    $updatePurchaseMasterInput: UpdatePurchaseMasterInput!
  ) {
    updatePurchaseMaster(
      updatePurchaseMasterInput: $updatePurchaseMasterInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const deletePurchaseMaster = /* GraphQL */ `
  mutation DeletePurchaseMaster(
    $PurchaseID: Int!
    $DeleteRemark: String
    $PaymentDeleteFlag: Int
  ) {
    deletePurchaseMaster(
      PurchaseID: $PurchaseID
      DeleteRemark: $DeleteRemark
      PaymentDeleteFlag: $PaymentDeleteFlag
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const createPurchaseTDSDetails = /* GraphQL */ `
  mutation CreatePurchaseTDSDetails(
    $createPurchaseTDSDetailsInput: CreatePurchaseTDSDetailsInput!
  ) {
    createPurchaseTDSDetails(
      createPurchaseTDSDetailsInput: $createPurchaseTDSDetailsInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePurchaseTDSDetails = /* GraphQL */ `
  mutation UpdatePurchaseTDSDetails(
    $updatePurchaseTDSDetailsInput: UpdatePurchaseTDSDetailsInput!
  ) {
    updatePurchaseTDSDetails(
      updatePurchaseTDSDetailsInput: $updatePurchaseTDSDetailsInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateCrDrNoteTDSDetails = /* GraphQL */ `
  mutation UpdateCrDrNoteTDSDetails(
    $updateCrDrNoteTDSDetailsInput: UpdateCrDrNoteTDSDetailsInput!
  ) {
    updateCrDrNoteTDSDetails(
      updateCrDrNoteTDSDetailsInput: $updateCrDrNoteTDSDetailsInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      TCSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateCrDrNoteTCSDetails = /* GraphQL */ `
  mutation UpdateCrDrNoteTCSDetails(
    $updateCrDrNoteTCSDetailsInput: UpdateCrDrNoteTCSDetailsInput!
  ) {
    updateCrDrNoteTCSDetails(
      updateCrDrNoteTCSDetailsInput: $updateCrDrNoteTCSDetailsInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TCSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TCSAmount
      AdjustmentAmount
      TCSSection
      TCSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      TCSPercentage
      __typename
    }
  }
`;
export const deletePurchaseTDSDetails = /* GraphQL */ `
  mutation DeletePurchaseTDSDetails($PurchaseID: Int!) {
    deletePurchaseTDSDetails(PurchaseID: $PurchaseID) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TDSAmount
      AdjustmentAmount
      TDSSection
      TDSPercentage
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseLineNonItems = /* GraphQL */ `
  mutation CreatePurchaseLineNonItems(
    $createPurchaseLineNonItemsInput: CreatePurchaseLineNonItemsInput!
  ) {
    createPurchaseLineNonItems(
      createPurchaseLineNonItemsInput: $createPurchaseLineNonItemsInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseLineItemType
      PurchaseAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      PurchaseAccountName
      __typename
    }
  }
`;
export const updatePurchaseLineNonItems = /* GraphQL */ `
  mutation UpdatePurchaseLineNonItems(
    $updatePurchaseLineNonItemsInput: UpdatePurchaseLineNonItemsInput!
  ) {
    updatePurchaseLineNonItems(
      updatePurchaseLineNonItemsInput: $updatePurchaseLineNonItemsInput
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseLineItemType
      PurchaseAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      PurchaseAccountName
      __typename
    }
  }
`;
export const deletePurchaseLineNonItems = /* GraphQL */ `
  mutation DeletePurchaseLineNonItems(
    $PurchaseID: Int!
    $PurchaseItemID: Int!
  ) {
    deletePurchaseLineNonItems(
      PurchaseID: $PurchaseID
      PurchaseItemID: $PurchaseItemID
    ) {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseLineItemType
      PurchaseAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      GSTRate
      GSTAmount
      CessAmount
      PurchaseAccountName
      __typename
    }
  }
`;
export const createTransactionAttachment = /* GraphQL */ `
  mutation CreateTransactionAttachment(
    $createTransactionAttachmentInput: CreateTransactionAttachmentInput!
  ) {
    createTransactionAttachment(
      createTransactionAttachmentInput: $createTransactionAttachmentInput
    ) {
      TransactionID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      DocumentName
      StatusCode
      StatusMessage
      Type
      __typename
    }
  }
`;
export const updateTransactionAttachment = /* GraphQL */ `
  mutation UpdateTransactionAttachment(
    $updateTransactionAttachmentInput: UpdateTransactionAttachmentInput!
  ) {
    updateTransactionAttachment(
      updateTransactionAttachmentInput: $updateTransactionAttachmentInput
    ) {
      TransactionID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      DocumentName
      StatusCode
      StatusMessage
      Type
      __typename
    }
  }
`;
export const deleteTransactionAttachment = /* GraphQL */ `
  mutation DeleteTransactionAttachment($AttachmentID: Int!) {
    deleteTransactionAttachment(AttachmentID: $AttachmentID) {
      TransactionID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      DocumentName
      StatusCode
      StatusMessage
      Type
      __typename
    }
  }
`;
export const createTransactionDetails = /* GraphQL */ `
  mutation CreateTransactionDetails(
    $createTransactionDetailsInput: CreateTransactionDetailsInput!
  ) {
    createTransactionDetails(
      createTransactionDetailsInput: $createTransactionDetailsInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      FinancialYearID
      __typename
    }
  }
`;
export const updateTransactionDetails = /* GraphQL */ `
  mutation UpdateTransactionDetails(
    $updateTransactionDetailsInput: UpdateTransactionDetailsInput!
  ) {
    updateTransactionDetails(
      updateTransactionDetailsInput: $updateTransactionDetailsInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      FinancialYearID
      __typename
    }
  }
`;
export const updatetransactionTimeStamp = /* GraphQL */ `
  mutation UpdatetransactionTimeStamp(
    $TransactionID: Int!
    $EnteredTimeStamp: Int!
  ) {
    updatetransactionTimeStamp(
      TransactionID: $TransactionID
      EnteredTimeStamp: $EnteredTimeStamp
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteTransactionDetails = /* GraphQL */ `
  mutation DeleteTransactionDetails($TransactionID: Int!) {
    deleteTransactionDetails(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      FinancialYearID
      __typename
    }
  }
`;
export const createTransactionMaster = /* GraphQL */ `
  mutation CreateTransactionMaster(
    $createTransactionMasterInput: CreateTransactionMasterInput!
  ) {
    createTransactionMaster(
      createTransactionMasterInput: $createTransactionMasterInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const updateTransactionMaster = /* GraphQL */ `
  mutation UpdateTransactionMaster(
    $updateTransactionMasterInput: UpdateTransactionMasterInput!
  ) {
    updateTransactionMaster(
      updateTransactionMasterInput: $updateTransactionMasterInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const deleteTransactionMaster = /* GraphQL */ `
  mutation DeleteTransactionMaster($TransactionID: Int!) {
    deleteTransactionMaster(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const createTransactionTDSDetails = /* GraphQL */ `
  mutation CreateTransactionTDSDetails(
    $createTransactionTDSDetailsInput: CreateTransactionTDSDetailsInput!
  ) {
    createTransactionTDSDetails(
      createTransactionTDSDetailsInput: $createTransactionTDSDetailsInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TDSAmount
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      TDSPercentage
      __typename
    }
  }
`;
export const updateTransactionTDSDetails = /* GraphQL */ `
  mutation UpdateTransactionTDSDetails(
    $updateTransactionTDSDetailsInput: UpdateTransactionTDSDetailsInput!
  ) {
    updateTransactionTDSDetails(
      updateTransactionTDSDetailsInput: $updateTransactionTDSDetailsInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TDSAmount
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      TDSPercentage
      __typename
    }
  }
`;
export const deleteTransactionTDSDetails = /* GraphQL */ `
  mutation DeleteTransactionTDSDetails($TransactionID: Int!) {
    deleteTransactionTDSDetails(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TDSApplicableCD
      TDSAmount
      TDSManual
      LastUpdatedBy
      StatusCode
      StatusMessage
      TDSPercentage
      __typename
    }
  }
`;
export const createAccountMaster = /* GraphQL */ `
  mutation CreateAccountMaster(
    $createAccountMasterInput: CreateAccountMasterInput!
  ) {
    createAccountMaster(createAccountMasterInput: $createAccountMasterInput) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const updateAccountMaster = /* GraphQL */ `
  mutation UpdateAccountMaster(
    $updateAccountMasterInput: UpdateAccountMasterInput!
  ) {
    updateAccountMaster(updateAccountMasterInput: $updateAccountMasterInput) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const deleteAccountMaster = /* GraphQL */ `
  mutation DeleteAccountMaster($AccountsID: Int!) {
    deleteAccountMaster(AccountsID: $AccountsID) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      RelatedAccountGSTDetails {
        AccountID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        EffectiveDate
        ExpiredDate
        HSNID
        GSTCompensationType
        GSTRate
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountOpeningBalance {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        FinancialYearID
        StartDate
        CreditAmount
        DebitAmount
        StatusCode
        StatusMessage
        __typename
      }
      RelatedAccountGroupMaster {
        AccountGroupID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountTypeCD
        AccountGroupName
        AccountParentGroupID
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Is_Active
        Restrictedflag
        __typename
      }
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;
export const createAccountGroupMaster = /* GraphQL */ `
  mutation CreateAccountGroupMaster(
    $createAccountGroupMasterInput: CreateAccountGroupMasterInput!
  ) {
    createAccountGroupMaster(
      createAccountGroupMasterInput: $createAccountGroupMasterInput
    ) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateAccountGroupMaster = /* GraphQL */ `
  mutation UpdateAccountGroupMaster(
    $updateAccountGroupMasterInput: UpdateAccountGroupMasterInput!
  ) {
    updateAccountGroupMaster(
      updateAccountGroupMasterInput: $updateAccountGroupMasterInput
    ) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const deleteAccountGroupMaster = /* GraphQL */ `
  mutation DeleteAccountGroupMaster($AccountGroupID: Int!) {
    deleteAccountGroupMaster(AccountGroupID: $AccountGroupID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createAccountGSTDetails = /* GraphQL */ `
  mutation CreateAccountGSTDetails(
    $createAccountGSTDetailsInput: CreateAccountGSTDetailsInput!
  ) {
    createAccountGSTDetails(
      createAccountGSTDetailsInput: $createAccountGSTDetailsInput
    ) {
      AccountID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateAccountGSTDetails = /* GraphQL */ `
  mutation UpdateAccountGSTDetails(
    $updateAccountGSTDetailsInput: UpdateAccountGSTDetailsInput!
  ) {
    updateAccountGSTDetails(
      updateAccountGSTDetailsInput: $updateAccountGSTDetailsInput
    ) {
      AccountID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteAccountGSTDetails = /* GraphQL */ `
  mutation DeleteAccountGSTDetails(
    $accountIDDelReqInput: AccountIDDelReqInput!
  ) {
    deleteAccountGSTDetails(accountIDDelReqInput: $accountIDDelReqInput) {
      AccountID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      EffectiveDate
      ExpiredDate
      HSNID
      GSTCompensationType
      GSTRate
      CessAmount
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createAccountOpeningBalance = /* GraphQL */ `
  mutation CreateAccountOpeningBalance(
    $createAccountOpeningBalanceInput: CreateAccountOpeningBalanceInput!
  ) {
    createAccountOpeningBalance(
      createAccountOpeningBalanceInput: $createAccountOpeningBalanceInput
    ) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      StartDate
      CreditAmount
      DebitAmount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateAccountOpeningBalance = /* GraphQL */ `
  mutation UpdateAccountOpeningBalance(
    $updateAccountOpeningBalanceInput: UpdateAccountOpeningBalanceInput!
  ) {
    updateAccountOpeningBalance(
      updateAccountOpeningBalanceInput: $updateAccountOpeningBalanceInput
    ) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      StartDate
      CreditAmount
      DebitAmount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteAccountOpeningBalance = /* GraphQL */ `
  mutation DeleteAccountOpeningBalance {
    deleteAccountOpeningBalance {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      StartDate
      CreditAmount
      DebitAmount
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createFinancialYear = /* GraphQL */ `
  mutation CreateFinancialYear(
    $createFinancialYearInput: CreateFinancialYearInput!
  ) {
    createFinancialYear(createFinancialYearInput: $createFinancialYearInput) {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const updateFinancialYear = /* GraphQL */ `
  mutation UpdateFinancialYear(
    $updateFinancialYearInput: UpdateFinancialYearInput!
  ) {
    updateFinancialYear(updateFinancialYearInput: $updateFinancialYearInput) {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const createUserPreference = /* GraphQL */ `
  mutation CreateUserPreference(
    $createUserPreferenceInput: CreateUserPreferenceInput!
  ) {
    createUserPreference(
      createUserPreferenceInput: $createUserPreferenceInput
    ) {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const deleteUserPreference = /* GraphQL */ `
  mutation DeleteUserPreference($UserID: String!, $AttributeTypeCD: String!) {
    deleteUserPreference(UserID: $UserID, AttributeTypeCD: $AttributeTypeCD) {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const updateUserPreference = /* GraphQL */ `
  mutation UpdateUserPreference(
    $updateUserPreferenceInput: UpdateUserPreferenceInput!
  ) {
    updateUserPreference(
      updateUserPreferenceInput: $updateUserPreferenceInput
    ) {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
  }
`;
export const deleteFinancialYear = /* GraphQL */ `
  mutation DeleteFinancialYear($FinancialYearID: Int!) {
    deleteFinancialYear(FinancialYearID: $FinancialYearID) {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const createFinancialYearStatus = /* GraphQL */ `
  mutation CreateFinancialYearStatus(
    $createFinancialYearStatusInput: CreateFinancialYearStatusInput!
  ) {
    createFinancialYearStatus(
      createFinancialYearStatusInput: $createFinancialYearStatusInput
    ) {
      FinancialYearID
      StatusTypeCD
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusValue
      UserID
      __typename
    }
  }
`;
export const updateFinancialYearStatus = /* GraphQL */ `
  mutation UpdateFinancialYearStatus(
    $updateFinancialYearStatusInput: UpdateFinancialYearStatusInput!
  ) {
    updateFinancialYearStatus(
      updateFinancialYearStatusInput: $updateFinancialYearStatusInput
    ) {
      FinancialYearID
      StatusTypeCD
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusValue
      UserID
      __typename
    }
  }
`;
export const deleteFinancialYearStatus = /* GraphQL */ `
  mutation DeleteFinancialYearStatus($FinancialYearID: Int!) {
    deleteFinancialYearStatus(FinancialYearID: $FinancialYearID) {
      FinancialYearID
      StatusTypeCD
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StatusValue
      UserID
      __typename
    }
  }
`;
export const createInvoiceTransactionMaster = /* GraphQL */ `
  mutation CreateInvoiceTransactionMaster(
    $createInvoiceTransactionmasterInput: CreateInvoiceTransactionmasterInput!
  ) {
    createInvoiceTransactionMaster(
      createInvoiceTransactionmasterInput: $createInvoiceTransactionmasterInput
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TransactionID
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      TCSApplicableFlag
      StatusCode
      StatusMessage
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      __typename
    }
  }
`;
export const createPurchaseTransactionMaster = /* GraphQL */ `
  mutation CreatePurchaseTransactionMaster(
    $createPurchaseTransactionMasterInput: CreatePurchaseTransactionMasterInput!
  ) {
    createPurchaseTransactionMaster(
      createPurchaseTransactionMasterInput: $createPurchaseTransactionMasterInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      TransactionID
      TransactionTypeCD
      BankReferenceNumber
      StatusCode
      StatusMessage
      CompanyState
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      __typename
    }
  }
`;
export const createCrDrNoteTransactionMaster = /* GraphQL */ `
  mutation CreateCrDrNoteTransactionMaster(
    $createCrDrNoteTransactionMasterInput: CreateCrDrNoteTransactionMasterInput!
  ) {
    createCrDrNoteTransactionMaster(
      createCrDrNoteTransactionMasterInput: $createCrDrNoteTransactionMasterInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      PlaceOfSupply
      ReverseChargeFlag
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      LastUpdatedBy
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CurrencyCode
      CurrencyRate
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      OriginalInvoiceNumber
      __typename
    }
  }
`;
export const createCrDrNoteMaster = /* GraphQL */ `
  mutation CreateCrDrNoteMaster(
    $createCrDrNoteMasterInput: CreateCrDrNoteMasterInput!
  ) {
    createCrDrNoteMaster(
      createCrDrNoteMasterInput: $createCrDrNoteMasterInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      RelatedCrDrNoteTCSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        __typename
      }
      RelatedCrDrNoteTDSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteDispatch {
        CrDrNoteID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      OriginalInvoiceNumber
      TotalGST
      TotalGSTCess
      TotalTaxableAmount
      TotalAdjustments
      Comments
      AccountID
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      PaymentStatus
      __typename
    }
  }
`;
export const updateCrDrNoteMaster = /* GraphQL */ `
  mutation UpdateCrDrNoteMaster(
    $updateCrDrNoteMasterInput: UpdateCrDrNoteMasterInput!
  ) {
    updateCrDrNoteMaster(
      updateCrDrNoteMasterInput: $updateCrDrNoteMasterInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      RelatedCrDrNoteTCSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        __typename
      }
      RelatedCrDrNoteTDSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteDispatch {
        CrDrNoteID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      OriginalInvoiceNumber
      TotalGST
      TotalGSTCess
      TotalTaxableAmount
      TotalAdjustments
      Comments
      AccountID
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      PaymentStatus
      __typename
    }
  }
`;
export const createCrDrNoteInvoices = /* GraphQL */ `
  mutation CreateCrDrNoteInvoices(
    $createCrDrNoteInvoicesInput: CreateCrDrNoteInvoicesInput!
  ) {
    createCrDrNoteInvoices(
      createCrDrNoteInvoicesInput: $createCrDrNoteInvoicesInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceID
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const updateCrDrNoteInvoices = /* GraphQL */ `
  mutation UpdateCrDrNoteInvoices(
    $updateCrDrNoteInvoicesInput: UpdateCrDrNoteInvoicesInput!
  ) {
    updateCrDrNoteInvoices(
      updateCrDrNoteInvoicesInput: $updateCrDrNoteInvoicesInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceID
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCrDrAttachment = /* GraphQL */ `
  mutation CreateCrDrAttachment(
    $createCrDrAttachmentInput: CreateCrDrAttachmentInput!
  ) {
    createCrDrAttachment(
      createCrDrAttachmentInput: $createCrDrAttachmentInput
    ) {
      CrDrNoteID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      UserID
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const updateCrDrAttachment = /* GraphQL */ `
  mutation UpdateCrDrAttachment(
    $updateCrDrAttachmentInput: UpdateCrDrAttachmentInput!
  ) {
    updateCrDrAttachment(
      updateCrDrAttachmentInput: $updateCrDrAttachmentInput
    ) {
      CrDrNoteID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      UserID
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createCrDrNoteDetails = /* GraphQL */ `
  mutation CreateCrDrNoteDetails(
    $createCrDrNoteDetailsInput: CreateCrDrNoteDetailsInput!
  ) {
    createCrDrNoteDetails(
      createCrDrNoteDetailsInput: $createCrDrNoteDetailsInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TotalTaxableAmount
      TotalGST
      TotalGSTCess
      TotalAdjustments
      Comments
      AccountID
      PartAmount
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateCrDrNoteDetails = /* GraphQL */ `
  mutation UpdateCrDrNoteDetails(
    $updateCrDrNoteDetailsInput: UpdateCrDrNoteDetailsInput!
  ) {
    updateCrDrNoteDetails(
      updateCrDrNoteDetailsInput: $updateCrDrNoteDetailsInput
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TotalTaxableAmount
      TotalGST
      TotalGSTCess
      TotalAdjustments
      Comments
      AccountID
      PartAmount
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCrDrNoteLineItems = /* GraphQL */ `
  mutation CreateCrDrNoteLineItems(
    $createCrDrNoteLineItemsInput: CreateCrDrNoteLineItemsInput!
  ) {
    createCrDrNoteLineItems(
      createCrDrNoteLineItemsInput: $createCrDrNoteLineItemsInput
    ) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      LineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      HSNSACCode
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      PriceType
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Unit
      UQC
      SalesAccountName
      PurchaseAccountName
      SalesAccountID
      PurchaseAccountID
      __typename
    }
  }
`;
export const updateCrDrNoteLineItems = /* GraphQL */ `
  mutation UpdateCrDrNoteLineItems(
    $updateCrDrNoteLineItemsInput: UpdateCrDrNoteLineItemsInput!
  ) {
    updateCrDrNoteLineItems(
      updateCrDrNoteLineItemsInput: $updateCrDrNoteLineItemsInput
    ) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      LineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      HSNSACCode
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      PriceType
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Unit
      UQC
      SalesAccountName
      PurchaseAccountName
      SalesAccountID
      PurchaseAccountID
      __typename
    }
  }
`;
export const createCrDrNoteLineNonItems = /* GraphQL */ `
  mutation CreateCrDrNoteLineNonItems(
    $createCrDrNoteLineNonItemsInput: CreateCrDrNoteLineNonItemsInput!
  ) {
    createCrDrNoteLineNonItems(
      createCrDrNoteLineNonItemsInput: $createCrDrNoteLineNonItemsInput
    ) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemType
      LedgerAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      LedgerAccountName
      __typename
    }
  }
`;
export const updateCrDrNoteLineNonItems = /* GraphQL */ `
  mutation UpdateCrDrNoteLineNonItems(
    $updateCrDrNoteLineNonItemsInput: UpdateCrDrNoteLineNonItemsInput!
  ) {
    updateCrDrNoteLineNonItems(
      updateCrDrNoteLineNonItemsInput: $updateCrDrNoteLineNonItemsInput
    ) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemType
      LedgerAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      LedgerAccountName
      __typename
    }
  }
`;
export const deleteCrDrNoteMaster = /* GraphQL */ `
  mutation DeleteCrDrNoteMaster($CrDrNoteID: Int!, $PaymentDeleteFlag: Int) {
    deleteCrDrNoteMaster(
      CrDrNoteID: $CrDrNoteID
      PaymentDeleteFlag: $PaymentDeleteFlag
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteInvoices {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceID
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      RelatedCrDrAttachment {
        CrDrNoteID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        UserID
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteLineItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        LineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        HSNSACCode
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        PriceType
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        Unit
        UQC
        SalesAccountName
        PurchaseAccountName
        SalesAccountID
        PurchaseAccountID
        __typename
      }
      RelatedCrDrNoteLineNonItems {
        CrDrNoteID
        CrDrNoteItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemType
        LedgerAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        GSTRate
        GSTTypeCD
        GSTAmount
        GSTCess
        NetAmount
        UserID
        Taxability
        Reason
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        LedgerAccountName
        __typename
      }
      RelatedCrDrNoteTCSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        __typename
      }
      RelatedCrDrNoteTDSDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TCSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedCrDrNoteDispatch {
        CrDrNoteID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      OriginalInvoiceNumber
      TotalGST
      TotalGSTCess
      TotalTaxableAmount
      TotalAdjustments
      Comments
      AccountID
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      PaymentStatus
      __typename
    }
  }
`;
export const deleteCrDrNoteInvoices = /* GraphQL */ `
  mutation DeleteCrDrNoteInvoices($CrDrNoteID: Int!) {
    deleteCrDrNoteInvoices(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceID
      StatusCode
      StatusMessage
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteCrDrAttachment = /* GraphQL */ `
  mutation DeleteCrDrAttachment($AttachmentID: Int!) {
    deleteCrDrAttachment(AttachmentID: $AttachmentID) {
      CrDrNoteID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      UserID
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const deleteCrDrNoteDetails = /* GraphQL */ `
  mutation DeleteCrDrNoteDetails($CrDrNoteID: Int!) {
    deleteCrDrNoteDetails(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TotalTaxableAmount
      TotalGST
      TotalGSTCess
      TotalAdjustments
      Comments
      AccountID
      PartAmount
      TransportationCD
      VehicleNumber
      DispatchDate
      EWAYBillNumber
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteCrDrNoteLineItems = /* GraphQL */ `
  mutation DeleteCrDrNoteLineItems($CrDrNoteID: Int!) {
    deleteCrDrNoteLineItems(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      LineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      HSNSACCode
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      PriceType
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      Unit
      UQC
      SalesAccountName
      PurchaseAccountName
      SalesAccountID
      PurchaseAccountID
      __typename
    }
  }
`;
export const deleteCrDrNoteLineNonItems = /* GraphQL */ `
  mutation DeleteCrDrNoteLineNonItems($CrDrNoteID: Int!) {
    deleteCrDrNoteLineNonItems(CrDrNoteID: $CrDrNoteID) {
      CrDrNoteID
      CrDrNoteItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemType
      LedgerAccountID
      HSNSACCode
      ItemDescription
      TaxableAmount
      GSTRate
      GSTTypeCD
      GSTAmount
      GSTCess
      NetAmount
      UserID
      Taxability
      Reason
      StatusCode
      StatusMessage
      HSNSACID
      HSNCodeType
      HSNCodeValue
      HSNDescription
      LedgerAccountName
      __typename
    }
  }
`;
export const createDebitDeliveryAddress = /* GraphQL */ `
  mutation CreateDebitDeliveryAddress(
    $CrDrNoteID: Int!
    $DeliveryAddress: String!
  ) {
    createDebitDeliveryAddress(
      CrDrNoteID: $CrDrNoteID
      DeliveryAddress: $DeliveryAddress
    ) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const createDebitBillingAddress = /* GraphQL */ `
  mutation CreateDebitBillingAddress(
    $CrDrNoteID: Int!
    $BillingAddress: String!
  ) {
    createDebitBillingAddress(
      CrDrNoteID: $CrDrNoteID
      BillingAddress: $BillingAddress
    ) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCreditDeliveryAddress = /* GraphQL */ `
  mutation CreateCreditDeliveryAddress(
    $CrDrNoteID: Int!
    $DeliveryAddress: String!
  ) {
    createCreditDeliveryAddress(
      CrDrNoteID: $CrDrNoteID
      DeliveryAddress: $DeliveryAddress
    ) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const createCreditBillingAddress = /* GraphQL */ `
  mutation CreateCreditBillingAddress(
    $CrDrNoteID: Int!
    $BillingAddress: String!
  ) {
    createCreditBillingAddress(
      CrDrNoteID: $CrDrNoteID
      BillingAddress: $BillingAddress
    ) {
      ID
      ObjectType
      ObjectID
      EnteredTimeStamp
      ExpiredTimeStamp
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
      __typename
    }
  }
`;
export const createBankDetails = /* GraphQL */ `
  mutation CreateBankDetails($createBankDetailsInput: CreateBankDetailsInput!) {
    createBankDetails(createBankDetailsInput: $createBankDetailsInput) {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectType
      EnteredTimeStamp
      ExpiredTimeStamp
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
      StatusCode
      StatusMessage
      RelatedAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const updateBankDetails = /* GraphQL */ `
  mutation UpdateBankDetails($updateBankDetailsInput: UpdateBankDetailsInput!) {
    updateBankDetails(updateBankDetailsInput: $updateBankDetailsInput) {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectType
      EnteredTimeStamp
      ExpiredTimeStamp
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
      StatusCode
      StatusMessage
      RelatedAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createTransactionRelation = /* GraphQL */ `
  mutation CreateTransactionRelation(
    $createTransactionRelationInput: CreateTransactionRelationInput!
  ) {
    createTransactionRelation(
      createTransactionRelationInput: $createTransactionRelationInput
    ) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateTransactionRelation = /* GraphQL */ `
  mutation UpdateTransactionRelation(
    $updateTransactionRelationInput: UpdateTransactionRelationInput!
  ) {
    updateTransactionRelation(
      updateTransactionRelationInput: $updateTransactionRelationInput
    ) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createDashboardData = /* GraphQL */ `
  mutation CreateDashboardData($StartDate: Int, $EndDate: Int) {
    createDashboardData(StartDate: $StartDate, EndDate: $EndDate) {
      ProfitAndLoss {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        GroupOrderNumber
        AccountGroupID
        AccountGroupName
        Debit
        Credit
        BalanceAmount
        FinancialYearID
        StartDate
        EndDate
        EnteredTimeStamp
        ExpiredTimeStamp
        TypeCD
        Restrictedflag
        __typename
      }
      Trialbalance {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        DisplayOrderNumber
        AccountGroupID
        AccountGroupName
        GroupOrderNumber
        Credit
        Debit
        BalanceAmount
        FinancialYearID
        StartDate
        EndDate
        EnteredTimeStamp
        ExpiredTimeStamp
        TypeCD
        Restrictedflag
        __typename
      }
      Balancesheet {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        AccountGroupID
        AccountGroupName
        GroupOrderNumber
        Credit
        Debit
        BalanceAmount
        TypeCD
        Restrictedflag
        __typename
      }
      StatusCode
      StatusMessage
      StartDate
      EndDate
      __typename
    }
  }
`;
export const createTrialBalanceDashboardData = /* GraphQL */ `
  mutation CreateTrialBalanceDashboardData(
    $StartDate: Int
    $EndDate: Int
    $OpeningBalance: Int
  ) {
    createTrialBalanceDashboardData(
      StartDate: $StartDate
      EndDate: $EndDate
      OpeningBalance: $OpeningBalance
    ) {
      Trialbalance {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        DisplayOrderNumber
        AccountGroupID
        AccountGroupName
        GroupOrderNumber
        Credit
        Debit
        BalanceAmount
        FinancialYearID
        StartDate
        EndDate
        EnteredTimeStamp
        ExpiredTimeStamp
        TypeCD
        Restrictedflag
        __typename
      }
      ProfitAndLoss {
        OpeningCreditAmount
        OpeningDebitAmount
        OpeningBalanceAmount
        NetProfit
        NetLoss
        __typename
      }
      StatusCode
      StatusMessage
      StartDate
      EndDate
      __typename
    }
  }
`;
export const createPandLDashboardData = /* GraphQL */ `
  mutation CreatePandLDashboardData(
    $StartDate: Int
    $EndDate: Int
    $OpeningBalance: Int
  ) {
    createPandLDashboardData(
      StartDate: $StartDate
      EndDate: $EndDate
      OpeningBalance: $OpeningBalance
    ) {
      ProfitAndLoss {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        GroupOrderNumber
        AccountGroupID
        AccountGroupName
        Debit
        Credit
        BalanceAmount
        FinancialYearID
        StartDate
        EndDate
        EnteredTimeStamp
        ExpiredTimeStamp
        TypeCD
        Restrictedflag
        __typename
      }
      StatusCode
      StatusMessage
      StartDate
      EndDate
      __typename
    }
  }
`;
export const createBalanceSheetDashboardData = /* GraphQL */ `
  mutation CreateBalanceSheetDashboardData(
    $StartDate: Int
    $EndDate: Int
    $OpeningBalance: Int
  ) {
    createBalanceSheetDashboardData(
      StartDate: $StartDate
      EndDate: $EndDate
      OpeningBalance: $OpeningBalance
    ) {
      Balancesheet {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        AccountGroupID
        AccountGroupName
        GroupOrderNumber
        Credit
        Debit
        BalanceAmount
        TypeCD
        Restrictedflag
        __typename
      }
      ProfitAndLoss {
        OpeningCreditAmount
        OpeningDebitAmount
        OpeningBalanceAmount
        NetProfit
        NetLoss
        __typename
      }
      StatusCode
      StatusMessage
      StartDate
      EndDate
      __typename
    }
  }
`;
export const createBalanceSheetDashboardDataTest = /* GraphQL */ `
  mutation CreateBalanceSheetDashboardDataTest {
    createBalanceSheetDashboardDataTest {
      Balancesheet {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        AccountGroupID
        AccountGroupName
        GroupOrderNumber
        Credit
        Debit
        BalanceAmount
        TypeCD
        Restrictedflag
        __typename
      }
      ProfitAndLoss {
        OpeningCreditAmount
        OpeningDebitAmount
        OpeningBalanceAmount
        NetProfit
        NetLoss
        __typename
      }
      StatusCode
      StatusMessage
      StartDate
      EndDate
      __typename
    }
  }
`;
export const nullDataTest = /* GraphQL */ `
  mutation NullDataTest {
    nullDataTest {
      Balancesheet {
        CompanyID
        CompanyBranchID
        AccountsID
        AccountTypeCD
        AccountName
        AccountGroupID
        AccountGroupName
        GroupOrderNumber
        Credit
        Debit
        BalanceAmount
        TypeCD
        Restrictedflag
        __typename
      }
      ProfitAndLoss {
        OpeningCreditAmount
        OpeningDebitAmount
        OpeningBalanceAmount
        NetProfit
        NetLoss
        __typename
      }
      StatusCode
      StatusMessage
      StartDate
      EndDate
      __typename
    }
  }
`;
export const deleteTransactionRelation = /* GraphQL */ `
  mutation DeleteTransactionRelation($TransactionID: Int, $ObjectID: Int) {
    deleteTransactionRelation(
      TransactionID: $TransactionID
      ObjectID: $ObjectID
    ) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteTransactionRelationOR = /* GraphQL */ `
  mutation DeleteTransactionRelationOR($TransactionID: Int, $ObjectID: Int) {
    deleteTransactionRelationOR(
      TransactionID: $TransactionID
      ObjectID: $ObjectID
    ) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteTransactionRelationIsDirect = /* GraphQL */ `
  mutation DeleteTransactionRelationIsDirect(
    $TransactionID: Int
    $ObjectID: Int
    $IsDirect: Int
  ) {
    deleteTransactionRelationIsDirect(
      TransactionID: $TransactionID
      ObjectID: $ObjectID
      IsDirect: $IsDirect
    ) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteTransactionRelationByObjectAttribute = /* GraphQL */ `
  mutation DeleteTransactionRelationByObjectAttribute(
    $TransactionID: Int
    $ObjectID: Int
    $ObjectAttribute: String
  ) {
    deleteTransactionRelationByObjectAttribute(
      TransactionID: $TransactionID
      ObjectID: $ObjectID
      ObjectAttribute: $ObjectAttribute
    ) {
      TransactionID
      TransactionTypeCD
      ObjectType
      ObjectID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LinkedAmount
      ObjectAttribute
      IsDirect
      LastUpdatedBy
      AccountID
      PaymentVoucherNumber
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createNumberTracker = /* GraphQL */ `
  mutation CreateNumberTracker(
    $createNumberTrackerInput: CreateNumberTrackerInput!
  ) {
    createNumberTracker(createNumberTrackerInput: $createNumberTrackerInput) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateNumberTracker = /* GraphQL */ `
  mutation UpdateNumberTracker(
    $updateNumberTrackerInput: UpdateNumberTrackerInput!
  ) {
    updateNumberTracker(updateNumberTrackerInput: $updateNumberTrackerInput) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteNumberTracker = /* GraphQL */ `
  mutation DeleteNumberTracker(
    $deleteNumberTrackerInput: DeleteNumberTrackerInput
  ) {
    deleteNumberTracker(deleteNumberTrackerInput: $deleteNumberTrackerInput) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteNumberTrackerByType = /* GraphQL */ `
  mutation DeleteNumberTrackerByType(
    $deleteNumberTrackerByTypeInput: DeleteNumberTrackerByTypeInput
  ) {
    deleteNumberTrackerByType(
      deleteNumberTrackerByTypeInput: $deleteNumberTrackerByTypeInput
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteNumberTrackerAuto = /* GraphQL */ `
  mutation DeleteNumberTrackerAuto(
    $deleteNumberTrackerAutoByTypeInput: DeleteNumberTrackerAutoByTypeInput
  ) {
    deleteNumberTrackerAuto(
      deleteNumberTrackerAutoByTypeInput: $deleteNumberTrackerAutoByTypeInput
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createClosingStock = /* GraphQL */ `
  mutation CreateClosingStock(
    $createClosingStockInput: CreateClosingStockInput!
  ) {
    createClosingStock(createClosingStockInput: $createClosingStockInput) {
      CompanyID
      CompanyBranchID
      Date
      ClosingBalance
      EnteredTimeStamp
      ExpiredTimeStamp
      LastUpdatedBy
      __typename
    }
  }
`;
export const deleteBankDetails = /* GraphQL */ `
  mutation DeleteBankDetails($BankDetailsID: Int!) {
    deleteBankDetails(BankDetailsID: $BankDetailsID) {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectType
      EnteredTimeStamp
      ExpiredTimeStamp
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
      StatusCode
      StatusMessage
      RelatedAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const createDenomination = /* GraphQL */ `
  mutation CreateDenomination(
    $createDenominationInput: CreateDenominationInput!
  ) {
    createDenomination(createDenominationInput: $createDenominationInput) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Denomination
      Number_Of_Notes
      TypeCD
      Last_Updated_By
      __typename
    }
  }
`;
export const updateDenomination = /* GraphQL */ `
  mutation UpdateDenomination(
    $updateDenominationInput: UpdateDenominationInput!
  ) {
    updateDenomination(updateDenominationInput: $updateDenominationInput) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      Denomination
      Number_Of_Notes
      TypeCD
      Last_Updated_By
      __typename
    }
  }
`;
export const closeFinancialYear = /* GraphQL */ `
  mutation CloseFinancialYear(
    $CurrentFinancialYearID: Int!
    $NextFinancialYearID: Int!
    $AccountIDList: String!
    $TransferFlag: Int!
  ) {
    closeFinancialYear(
      CurrentFinancialYearID: $CurrentFinancialYearID
      NextFinancialYearID: $NextFinancialYearID
      AccountIDList: $AccountIDList
      TransferFlag: $TransferFlag
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPOSParty = /* GraphQL */ `
  mutation CreatePOSParty($createPOSPartyInput: CreatePOSPartyInput!) {
    createPOSParty(createPOSPartyInput: $createPOSPartyInput) {
      PosPartyID
      CompanyID
      PartyName
      PartyContactNumberID
      LastUpdatedBy
      EnteredTimeStamp
      ExpiredTimeStamp
      RelatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      __typename
    }
  }
`;
export const cancelInvoiceMaster = /* GraphQL */ `
  mutation CancelInvoiceMaster(
    $updateInvoicemasterInput: UpdateInvoicemasterInput!
  ) {
    cancelInvoiceMaster(updateInvoicemasterInput: $updateInvoicemasterInput) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        UQC
        SalesAccountName
        SalesAccountID
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        IncomeAccountName
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      PartyEmail
      is_cancelled
      cancel_reason
      cancel_remarks
      __typename
    }
  }
`;
export const cancelPurchaseMaster = /* GraphQL */ `
  mutation CancelPurchaseMaster(
    $updatePurchaseMasterInput: UpdatePurchaseMasterInput!
  ) {
    cancelPurchaseMaster(
      updatePurchaseMasterInput: $updatePurchaseMasterInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTDSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TDSAmount
        AdjustmentAmount
        TDSSection
        TDSPercentage
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseTCSDetails {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          Description
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNSACCode
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        Unit
        UQC
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineNonItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseLineItemType
        PurchaseAccountID
        HSNSACCode
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        Taxability
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTAmount
        CessAmount
        PurchaseAccountName
        __typename
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseLineNonGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedPurchaseAttachment {
        PurchaseID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            UQC
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            PurchaseAccountName
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              Description
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            UQC
            SalesAccountName
            SalesAccountID
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            IncomeAccountName
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                UQC
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                PurchaseAccountName
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                UQC
                SalesAccountName
                SalesAccountID
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                IncomeAccountName
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        AccountTypeFlag
        __typename
      }
      RelatedPartyAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      ReverseChargeFlag
      OverdueDays
      PaymentStatus
      PartyRegistrationType
      __typename
    }
  }
`;
export const cancelTransactionMaster = /* GraphQL */ `
  mutation CancelTransactionMaster(
    $updateTransactionMasterInput: UpdateTransactionMasterInput!
  ) {
    cancelTransactionMaster(
      updateTransactionMasterInput: $updateTransactionMasterInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        FinancialYearID
        __typename
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        StatusCode
        StatusMessage
        Type
        __typename
      }
      RelatedTransactionTDSDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TDSApplicableCD
        TDSAmount
        TDSManual
        LastUpdatedBy
        StatusCode
        StatusMessage
        TDSPercentage
        __typename
      }
      RelatedPurchaseMaster {
        PurchaseID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PurchaseGSTTypeCD
        SupplierID
        EntryDate
        VoucherNumber
        SupplierInvoiceDate
        SupplierInvoiceNumber
        SupplierAddressID
        PaymentTypeCD
        PaidAmount
        CreditDuration
        PaymentAccountID
        Comments
        TDSApplicableFlag
        GrantTotalAmount
        BalanceDueAmount
        PaymentClearedFlag
        PlaceOfSupply
        CompanyState
        RelatedPurchaseTDSDetails {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TotalTaxableAmount
          IneligibleTCFlag
          ReverseChargeFlag
          GSTCessTotal
          TDSAmount
          AdjustmentAmount
          TDSSection
          TDSPercentage
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseLineItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemNumber
          ItemID
          PurchaseAccountID
          HSNCode
          ItemQuantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNSACCode
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          Unit
          UQC
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineNonItems {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseLineItemType
          PurchaseAccountID
          HSNSACCode
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          Taxability
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTAmount
          CessAmount
          PurchaseAccountName
          __typename
        }
        RelatedPurchaseLineGST {
          PurchaseID
          PurchaseItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          CessAmount
          GSTAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedPurchaseAttachment {
          PurchaseID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedPurchaseTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        RelatedPurchaseTransactionRelation {
          TransactionID
          TransactionTypeCD
          ObjectType
          ObjectID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LinkedAmount
          ObjectAttribute
          IsDirect
          LastUpdatedBy
          AccountID
          PaymentVoucherNumber
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        CancelFlag
        RoundOffAmount
        DiscountType
        DiscountValue
        AdjustmentAmount
        SerialNumber
        CurrencyCode
        CurrencyRate
        ReverseChargeFlag
        PaymentStatus
        PartyRegistrationType
        __typename
      }
      RelatedInvoiceMaster {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceTypeCD
        PartyID
        PaymentAccountID
        InvoiceDate
        InvoiceNumber
        CustomerOrderNumber
        CustomerOrderDate
        InvoiceAmount
        PaymentType
        CreditDuration
        InvoiceBillingAddressID
        InvoiceDeliveryAddressID
        InvoiceTaxableTypeCD
        ReceiptURL
        InvoiceLineTypeCD
        InvoiceCurrencyCD
        ExchangeRate
        Comments
        ReceivedAmount
        AdjustmentAmount
        PlaceOfSupply
        BalanceDueAmount
        ReverseChargeFlag
        TCSApplicableFlag
        RelatedInvoiceLineItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          LineItemNumber
          InvoiceLineItemType
          ItemID
          Quantity
          UnitTypeCD
          ItemRate
          ItemAmount
          ItemDiscount
          NetAmount
          HSNSACCode
          Taxability
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedItemMaster {
            ItemID
            ItemCode
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemName
            SalesInvoiceFlag
            PurchaseInvoiceFlag
            ItemCategoryCD
            MeasurementCD
            CurrencyCD
            SalesAccountID
            PurchaseAccountID
            TaxabilityCD
            ReverseChargeFlag
            ItemType
            HSNID
            Is_Active
            StatusCode
            StatusMessage
            relatedItemAmountDetails {
              ItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              Amount
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTCompensationValue
              GSTRATE
              StatusCode
              StatusMessage
              LastUpdatedBy
              DiscountType
              DiscountValue
              InvoiceType
              PriceType
              IsActive
              IsDefault
              __typename
            }
            relatedItemGstDetails {
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              HSNID
              GSTCessType
              GSTCompensationValue
              EffectiveDate
              ExpiredDate
              GSTCessValue
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            relatedItemImages {
              AttachmentID
              ItemID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ImageName
              ImageURL
              DocumentName
              Type
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            SerialNumber
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            Description
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          PriceType
          LotID
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          Unit
          UQC
          SalesAccountName
          SalesAccountID
          __typename
        }
        RelatedInvoiceLineNonItems {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceLineItemType
          IncomeAccountID
          HSNSACCode
          Taxability
          ItemDescription
          TaxableAmount
          NetAmount
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          IncomeAccountName
          __typename
        }
        RelatedInvoiceAttachment {
          InvoiceID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          DocumentName
          Type
          __typename
        }
        RelatedInvoiceDispatch {
          InvoiceID
          DispatchID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransportationCD
          VehicleNumber
          DispatchDate
          EWayBillNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoicePOSDetails {
          POSID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PartyPOSID
          LastUpdatedBy
          RelatedPOSParty {
            PosPartyID
            CompanyID
            PartyName
            PartyContactNumberID
            LastUpdatedBy
            EnteredTimeStamp
            ExpiredTimeStamp
            RelatedPhoneContacts {
              ID
              ObjectType
              ObjectID
              EnteredTimeStamp
              ExpiredTimeStamp
              CountryCode
              PhoneNumber
              VerifiedDateTime
              PromotionsSignup
              SMSAllowed
              CallAllowed
              WhatsappAllowed
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            __typename
          }
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedInvoiceNumberTracker {
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          NextInvoiceNumber
          LastUpdatedBy
          __typename
        }
        RelatedInvoiceTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          VoucherNumber
          EntryDate
          BankReferenceNumber
          Comments
          RelatedTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            AccountID
            CreditAmount
            DebitAmount
            Comments
            EntryOrderNumber
            TransactionBalance
            OpeningBalance
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            FinancialYearID
            __typename
          }
          RelatedTransactionAttachment {
            TransactionID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            DocumentName
            StatusCode
            StatusMessage
            Type
            __typename
          }
          RelatedTransactionTDSDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TDSAmount
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            TDSPercentage
            __typename
          }
          RelatedPurchaseMaster {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseGSTTypeCD
            SupplierID
            EntryDate
            VoucherNumber
            SupplierInvoiceDate
            SupplierInvoiceNumber
            SupplierAddressID
            PaymentTypeCD
            PaidAmount
            CreditDuration
            PaymentAccountID
            Comments
            TDSApplicableFlag
            GrantTotalAmount
            BalanceDueAmount
            PaymentClearedFlag
            PlaceOfSupply
            CompanyState
            RelatedPurchaseTDSDetails {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TotalTaxableAmount
              IneligibleTCFlag
              ReverseChargeFlag
              GSTCessTotal
              TDSAmount
              AdjustmentAmount
              TDSSection
              TDSPercentage
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseLineItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemNumber
              ItemID
              PurchaseAccountID
              HSNCode
              ItemQuantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNSACCode
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              Unit
              UQC
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineNonItems {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseLineItemType
              PurchaseAccountID
              HSNSACCode
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              Taxability
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTAmount
              CessAmount
              PurchaseAccountName
              __typename
            }
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedPurchaseAttachment {
              PurchaseID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedPurchaseTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            RelatedPurchaseTransactionRelation {
              TransactionID
              TransactionTypeCD
              ObjectType
              ObjectID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LinkedAmount
              ObjectAttribute
              IsDirect
              LastUpdatedBy
              AccountID
              PaymentVoucherNumber
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            CancelFlag
            RoundOffAmount
            DiscountType
            DiscountValue
            AdjustmentAmount
            SerialNumber
            CurrencyCode
            CurrencyRate
            ReverseChargeFlag
            PaymentStatus
            PartyRegistrationType
            __typename
          }
          RelatedInvoiceMaster {
            InvoiceID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceTypeCD
            PartyID
            PaymentAccountID
            InvoiceDate
            InvoiceNumber
            CustomerOrderNumber
            CustomerOrderDate
            InvoiceAmount
            PaymentType
            CreditDuration
            InvoiceBillingAddressID
            InvoiceDeliveryAddressID
            InvoiceTaxableTypeCD
            ReceiptURL
            InvoiceLineTypeCD
            InvoiceCurrencyCD
            ExchangeRate
            Comments
            ReceivedAmount
            AdjustmentAmount
            PlaceOfSupply
            BalanceDueAmount
            ReverseChargeFlag
            TCSApplicableFlag
            RelatedInvoiceLineItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              LineItemNumber
              InvoiceLineItemType
              ItemID
              Quantity
              UnitTypeCD
              ItemRate
              ItemAmount
              ItemDiscount
              NetAmount
              HSNSACCode
              Taxability
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedItemMaster {
                ItemID
                ItemCode
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemName
                SalesInvoiceFlag
                PurchaseInvoiceFlag
                ItemCategoryCD
                MeasurementCD
                CurrencyCD
                SalesAccountID
                PurchaseAccountID
                TaxabilityCD
                ReverseChargeFlag
                ItemType
                HSNID
                Is_Active
                StatusCode
                StatusMessage
                LastUpdatedBy
                SerialNumber
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                Description
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              PriceType
              LotID
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              Unit
              UQC
              SalesAccountName
              SalesAccountID
              __typename
            }
            RelatedInvoiceLineNonItems {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceLineItemType
              IncomeAccountID
              HSNSACCode
              Taxability
              ItemDescription
              TaxableAmount
              NetAmount
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              IncomeAccountName
              __typename
            }
            RelatedInvoiceAttachment {
              InvoiceID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              StatusCode
              StatusMessage
              DocumentName
              Type
              __typename
            }
            RelatedInvoiceDispatch {
              InvoiceID
              DispatchID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransportationCD
              VehicleNumber
              DispatchDate
              EWayBillNumber
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoicePOSDetails {
              POSID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PartyPOSID
              LastUpdatedBy
              RelatedPOSParty {
                PosPartyID
                CompanyID
                PartyName
                PartyContactNumberID
                LastUpdatedBy
                EnteredTimeStamp
                ExpiredTimeStamp
                __typename
              }
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedInvoiceNumberTracker {
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              NextInvoiceNumber
              LastUpdatedBy
              __typename
            }
            RelatedInvoiceTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              VoucherNumber
              EntryDate
              BankReferenceNumber
              Comments
              RelatedTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                AccountID
                CreditAmount
                DebitAmount
                Comments
                EntryOrderNumber
                TransactionBalance
                OpeningBalance
                LastUpdatedBy
                StatusCode
                StatusMessage
                FinancialYearID
                __typename
              }
              RelatedTransactionAttachment {
                TransactionID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                DocumentName
                StatusCode
                StatusMessage
                Type
                __typename
              }
              RelatedTransactionTDSDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TDSAmount
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                TDSPercentage
                __typename
              }
              RelatedPurchaseMaster {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseGSTTypeCD
                SupplierID
                EntryDate
                VoucherNumber
                SupplierInvoiceDate
                SupplierInvoiceNumber
                SupplierAddressID
                PaymentTypeCD
                PaidAmount
                CreditDuration
                PaymentAccountID
                Comments
                TDSApplicableFlag
                GrantTotalAmount
                BalanceDueAmount
                PaymentClearedFlag
                PlaceOfSupply
                CompanyState
                LastUpdatedBy
                CancelFlag
                RoundOffAmount
                DiscountType
                DiscountValue
                AdjustmentAmount
                SerialNumber
                CurrencyCode
                CurrencyRate
                ReverseChargeFlag
                PaymentStatus
                PartyRegistrationType
                __typename
              }
              RelatedInvoiceMaster {
                InvoiceID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceTypeCD
                PartyID
                PaymentAccountID
                InvoiceDate
                InvoiceNumber
                CustomerOrderNumber
                CustomerOrderDate
                InvoiceAmount
                PaymentType
                CreditDuration
                InvoiceBillingAddressID
                InvoiceDeliveryAddressID
                InvoiceTaxableTypeCD
                ReceiptURL
                InvoiceLineTypeCD
                InvoiceCurrencyCD
                ExchangeRate
                Comments
                ReceivedAmount
                AdjustmentAmount
                PlaceOfSupply
                BalanceDueAmount
                ReverseChargeFlag
                TCSApplicableFlag
                LastUpdatedBy
                CancelFlag
                StatusCode
                StatusMessage
                ConsigneeName
                ConsigneeGSTIN
                CompanyState
                CancelRemark
                DeleteRemark
                RoundOffAmount
                DiscountType
                DiscountValue
                SerialNumber
                CurrencyCode
                CurrencyRate
                PaymentStatus
                AckNo
                AckDt
                Irn
                SignedQRCode
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              CancelFlag
              CancelRemark
              SerialNumber
              __typename
            }
            LastUpdatedBy
            CancelFlag
            StatusCode
            StatusMessage
            ConsigneeName
            ConsigneeGSTIN
            CompanyState
            CancelRemark
            DeleteRemark
            RoundOffAmount
            DiscountType
            DiscountValue
            SerialNumber
            CurrencyCode
            CurrencyRate
            PaymentStatus
            AckNo
            AckDt
            Irn
            SignedQRCode
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          CancelFlag
          CancelRemark
          SerialNumber
          __typename
        }
        LastUpdatedBy
        CancelFlag
        StatusCode
        StatusMessage
        ConsigneeName
        ConsigneeGSTIN
        CompanyState
        CancelRemark
        DeleteRemark
        RoundOffAmount
        DiscountType
        DiscountValue
        SerialNumber
        CurrencyCode
        CurrencyRate
        PaymentStatus
        AckNo
        AckDt
        Irn
        SignedQRCode
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      CancelRemark
      SerialNumber
      __typename
    }
  }
`;
export const updatePOSParty = /* GraphQL */ `
  mutation UpdatePOSParty($updatePOSPartyInput: UpdatePOSPartyInput!) {
    updatePOSParty(updatePOSPartyInput: $updatePOSPartyInput) {
      PosPartyID
      CompanyID
      PartyName
      PartyContactNumberID
      LastUpdatedBy
      EnteredTimeStamp
      ExpiredTimeStamp
      RelatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      __typename
    }
  }
`;
export const transferAccountsToFinancialYear = /* GraphQL */ `
  mutation TransferAccountsToFinancialYear(
    $AccountIDList: String!
    $AccountGroupList: String!
    $From_FinancialYearID: Int!
    $To_FinancialYearID: Int!
    $TransferFlag: Int!
  ) {
    transferAccountsToFinancialYear(
      AccountIDList: $AccountIDList
      AccountGroupList: $AccountGroupList
      From_FinancialYearID: $From_FinancialYearID
      To_FinancialYearID: $To_FinancialYearID
      TransferFlag: $TransferFlag
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createLUTBondMaster = /* GraphQL */ `
  mutation CreateLUTBondMaster(
    $createLUTBondMasterInput: CreateLUTBondMasterInput!
  ) {
    createLUTBondMaster(createLUTBondMasterInput: $createLUTBondMasterInput) {
      ID
      LUTNo
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ValidFrom
      ValidTo
      FinancialYearID
      __typename
    }
  }
`;
export const updateLUTBondMaster = /* GraphQL */ `
  mutation UpdateLUTBondMaster(
    $updateLUTBondMasterInput: UpdateLUTBondMasterInput!
  ) {
    updateLUTBondMaster(updateLUTBondMasterInput: $updateLUTBondMasterInput) {
      ID
      LUTNo
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ValidFrom
      ValidTo
      FinancialYearID
      __typename
    }
  }
`;
export const deleteLUTBondMaster = /* GraphQL */ `
  mutation DeleteLUTBondMaster($ID: Int!) {
    deleteLUTBondMaster(ID: $ID) {
      ID
      LUTNo
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ValidFrom
      ValidTo
      FinancialYearID
      __typename
    }
  }
`;
export const createInvoiceSettings = /* GraphQL */ `
  mutation CreateInvoiceSettings($invoiceSettingsInput: InvoiceSettingsInput!) {
    createInvoiceSettings(invoiceSettingsInput: $invoiceSettingsInput) {
      InvoiceSettingsID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      TypeCD
      InvoiceHeading
      SignatureText
      DeclarationAtFooter
      TermsAndCondition
      DeclarationAtFooterFlag
      TermsAndConditionsFlag
      CompanyName
      CompanyCIN
      InvoiceNumber
      CompanyAddress
      CompanyLogo
      InvoiceDate
      CompanyContactNumber
      CompanyEmail
      PaymentMode
      CompanyGSTIN
      CompanyWebsite
      CreditPeriod
      CompanyPAN
      CompanyBankDetails
      PaymentDueDate
      CustomerLegalName
      CustomerGSTIN
      LUTBondDetails
      CustomerDisplayName
      PlaceOfSupply
      DispatchDetails
      CustomerBillingAddress
      CustomerContactPerson
      CustomerContactNumber
      CustomerName
      EWayBillDetails
      CustomerShippingAddress
      CustomerOrderNoAndDate
      EInvoiceDetails
      ItemWiseDiscount
      HSNSACode
      ShowRoundOff
      HSNSASummaryTable
      InvoiceDescription
      RegularInvoiceSignatureFileName
      LastUpdatedBy
      StatusCode
      StatusMessage
      PosInvoiceSignatureFileName
      DefaultSetting
      BankDetails
      UPI_ID
      __typename
    }
  }
`;
export const createPOSInvoiceSettings = /* GraphQL */ `
  mutation CreatePOSInvoiceSettings(
    $invoiceSettingsInput: InvoiceSettingsInput
  ) {
    createPOSInvoiceSettings(invoiceSettingsInput: $invoiceSettingsInput) {
      InvoiceSettingsID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      TypeCD
      InvoiceHeading
      SignatureText
      DeclarationAtFooter
      TermsAndCondition
      DeclarationAtFooterFlag
      TermsAndConditionsFlag
      CompanyName
      CompanyCIN
      InvoiceNumber
      CompanyAddress
      CompanyLogo
      InvoiceDate
      CompanyContactNumber
      CompanyEmail
      PaymentMode
      CompanyGSTIN
      CompanyWebsite
      CreditPeriod
      CompanyPAN
      CompanyBankDetails
      PaymentDueDate
      CustomerLegalName
      CustomerGSTIN
      LUTBondDetails
      CustomerDisplayName
      PlaceOfSupply
      DispatchDetails
      CustomerBillingAddress
      CustomerContactPerson
      CustomerContactNumber
      CustomerName
      EWayBillDetails
      CustomerShippingAddress
      CustomerOrderNoAndDate
      EInvoiceDetails
      ItemWiseDiscount
      HSNSACode
      ShowRoundOff
      HSNSASummaryTable
      InvoiceDescription
      RegularInvoiceSignatureFileName
      LastUpdatedBy
      StatusCode
      StatusMessage
      PosInvoiceSignatureFileName
      DefaultSetting
      BankDetails
      UPI_ID
      __typename
    }
  }
`;
export const createInvoiceTCSDetails = /* GraphQL */ `
  mutation CreateInvoiceTCSDetails(
    $createInvoiceTCSDetailsInput: CreateInvoiceTCSDetailsInput!
  ) {
    createInvoiceTCSDetails(
      createInvoiceTCSDetailsInput: $createInvoiceTCSDetailsInput
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TCSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TCSAmount
      AdjustmentAmount
      TCSSection
      LastUpdatedBy
      StatusCode
      StatusMessage
      TCSPercentage
      TCSManual
      __typename
    }
  }
`;
export const updateInvoiceTCSDetails = /* GraphQL */ `
  mutation UpdateInvoiceTCSDetails(
    $updateInvoiceTCSDetailsInput: UpdateInvoiceTCSDetailsInput!
  ) {
    updateInvoiceTCSDetails(
      updateInvoiceTCSDetailsInput: $updateInvoiceTCSDetailsInput
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TCSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TCSAmount
      AdjustmentAmount
      TCSSection
      LastUpdatedBy
      StatusCode
      StatusMessage
      TCSPercentage
      TCSManual
      __typename
    }
  }
`;
export const updatePurchaseTCSDetails = /* GraphQL */ `
  mutation UpdatePurchaseTCSDetails(
    $updatePurchaseTCSDetailsInput: UpdatePurchaseTCSDetailsInput!
  ) {
    updatePurchaseTCSDetails(
      updatePurchaseTCSDetailsInput: $updatePurchaseTCSDetailsInput
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TCSApplicableCD
      TotalTaxableAmount
      IneligibleTCFlag
      ReverseChargeFlag
      GSTCessTotal
      TCSAmount
      AdjustmentAmount
      TCSSection
      LastUpdatedBy
      StatusCode
      StatusMessage
      TCSPercentage
      TCSManual
      __typename
    }
  }
`;
export const createSalesInvoice = /* GraphQL */ `
  mutation CreateSalesInvoice(
    $createSalesInvoiceInput: CreateSalesInvoiceInput!
  ) {
    createSalesInvoice(createSalesInvoiceInput: $createSalesInvoiceInput) {
      InvoiceID
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createAccountOpeningBalancesTransaction = /* GraphQL */ `
  mutation CreateAccountOpeningBalancesTransaction(
    $createAccountOpeningBalancesArrayInput: CreateAccountOpeningBalancesArrayInput!
  ) {
    createAccountOpeningBalancesTransaction(
      createAccountOpeningBalancesArrayInput: $createAccountOpeningBalancesArrayInput
    ) {
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createPurchaseInvoice = /* GraphQL */ `
  mutation CreatePurchaseInvoice(
    $createPurchaseInvoiceInput: CreatePurchaseInvoiceInput!
  ) {
    createPurchaseInvoice(
      createPurchaseInvoiceInput: $createPurchaseInvoiceInput
    ) {
      PurchaseID
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCrDrNoteTransactionsArray = /* GraphQL */ `
  mutation CreateCrDrNoteTransactionsArray(
    $createCrDrNoteTransactionsArrayInput: CreateCrDrNoteTransactionsArrayInput!
  ) {
    createCrDrNoteTransactionsArray(
      createCrDrNoteTransactionsArrayInput: $createCrDrNoteTransactionsArrayInput
    ) {
      CrDrNoteID
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createUserIssue = /* GraphQL */ `
  mutation CreateUserIssue($userIssueInput: UserIssueInput) {
    createUserIssue(userIssueInput: $userIssueInput) {
      StatusMessage
      StatusCode
      __typename
    }
  }
`;
export const createTransactionDetailsArray = /* GraphQL */ `
  mutation CreateTransactionDetailsArray(
    $createTransactionDetailsArrayInput: AWSJSON!
  ) {
    createTransactionDetailsArray(
      createTransactionDetailsArrayInput: $createTransactionDetailsArrayInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      RelatedAccountsTransaction {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        VoucherNumber
        TransactionMasterTypeCD
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        FinancialYearID
        __typename
      }
      LastUpdatedBy
      FinancialYearID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const uploadCompanyDocumentsArray = /* GraphQL */ `
  mutation UploadCompanyDocumentsArray(
    $createCompanyDocumentsArrayInput: AWSJSON!
  ) {
    uploadCompanyDocumentsArray(
      createCompanyDocumentsArrayInput: $createCompanyDocumentsArrayInput
    ) {
      ID
      CompanyID
      PartyID
      DocumentType
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      LastUpdatedBy
      IsActive
      Type
      DocumentName
      __typename
    }
  }
`;
export const deleteCompanyDocumentsArray = /* GraphQL */ `
  mutation DeleteCompanyDocumentsArray(
    $deleteCompanyDocumentsIDInput: AWSJSON!
  ) {
    deleteCompanyDocumentsArray(
      deleteCompanyDocumentsIDInput: $deleteCompanyDocumentsIDInput
    ) {
      ID
      CompanyID
      PartyID
      DocumentType
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      LastUpdatedBy
      IsActive
      Type
      DocumentName
      __typename
    }
  }
`;
export const switchCompany = /* GraphQL */ `
  mutation SwitchCompany($CompanyID: Int!) {
    switchCompany(CompanyID: $CompanyID) {
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const cancelPartyMaster = /* GraphQL */ `
  mutation CancelPartyMaster($updatePartyMasterInput: UpdatePartyMasterInput!) {
    cancelPartyMaster(updatePartyMasterInput: $updatePartyMasterInput) {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        PANNummber
        GSTIN
        PartyAddressID
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyContact {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      AccountTypeFlag
      __typename
    }
  }
`;
export const cancelCompanyCodeTranslation = /* GraphQL */ `
  mutation CancelCompanyCodeTranslation(
    $updateCompanyCodeTranslationInput: UpdateCompanyCodeTranslationInput!
  ) {
    cancelCompanyCodeTranslation(
      updateCompanyCodeTranslationInput: $updateCompanyCodeTranslationInput
    ) {
      ID
      CompanyID
      CodeType
      CodeValue
      Language
      EnteredTimeStamp
      ExpiredTimeStamp
      CodeText
      CodeOrder
      StatusCode
      StatusMessage
      LastUpdatedBy
      UQC
      Is_Active
      __typename
    }
  }
`;
export const createPartyTransaction = /* GraphQL */ `
  mutation CreatePartyTransaction(
    $createPartyTransactionInput: CreatePartyTransactionInput!
  ) {
    createPartyTransaction(
      createPartyTransactionInput: $createPartyTransactionInput
    ) {
      PartyID
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createItemTransaction = /* GraphQL */ `
  mutation CreateItemTransaction(
    $createItemTransactionInput: CreateItemTransactionInput!
  ) {
    createItemTransaction(
      createItemTransactionInput: $createItemTransactionInput
    ) {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
      LastUpdatedBy
      ItemAmountEnteredTimeStamp
      ItemAmountExpiredTimeStamp
      Amount
      EffectiveDate
      ExpiredDate
      ItemAmountHSNID
      GSTCompensationType
      GSTCompensationValue
      GSTRATE
      DiscountType
      DiscountValue
      ImageName
      ImageURL
      SerialNumber
      IsDefault
      InvoiceType
      DefaultSellingPrice
      DefaultPurchasePrice
      CodeText
      ItemCategory
      SellingGSTCompensationType
      PurchaseGSTCompensationType
      SellingGSTCompensationValue
      PurchaseGSTCompensationValue
      SellingGSTRATE
      PurchaseGSTRATE
      SellingDiscountType
      PurchaseDiscountType
      SellingDiscountValue
      PurchaseDiscountValue
      Description
      __typename
    }
  }
`;
export const updatePartyImagesArray = /* GraphQL */ `
  mutation UpdatePartyImagesArray($updatePartyImagesArrayInput: AWSJSON!) {
    updatePartyImagesArray(
      updatePartyImagesArrayInput: $updatePartyImagesArrayInput
    ) {
      AttachmentID
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      Type
      DocumentName
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createCompanyDropdownValues = /* GraphQL */ `
  mutation CreateCompanyDropdownValues(
    $createCompanyDropdownValuesInput: CreateCompanyDropdownValuesInput!
  ) {
    createCompanyDropdownValues(
      createCompanyDropdownValuesInput: $createCompanyDropdownValuesInput
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const deleteBusinessTypeDropdown = /* GraphQL */ `
  mutation DeleteBusinessTypeDropdown($BusinessTypeID: Int!) {
    deleteBusinessTypeDropdown(BusinessTypeID: $BusinessTypeID) {
      BusinessTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      BusinessType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const deleteIndustryTypeDropdown = /* GraphQL */ `
  mutation DeleteIndustryTypeDropdown($IndustryTypeID: Int!) {
    deleteIndustryTypeDropdown(IndustryTypeID: $IndustryTypeID) {
      IndustryTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      IndustryType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const deleteEntityTypeDropdown = /* GraphQL */ `
  mutation DeleteEntityTypeDropdown($EntityTypeID: Int!) {
    deleteEntityTypeDropdown(EntityTypeID: $EntityTypeID) {
      EntityTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      EntityType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const loginCognitoUser = /* GraphQL */ `
  mutation LoginCognitoUser($LinkedSessionID: String) {
    loginCognitoUser(LinkedSessionID: $LinkedSessionID) {
      SessionID
      CognitoUsername
      LoginTimestamp
      LogoutTimestamp
      LinkedSessionID
      __typename
    }
  }
`;
export const logoutCognitoUser = /* GraphQL */ `
  mutation LogoutCognitoUser {
    logoutCognitoUser {
      SessionID
      CognitoUsername
      LoginTimestamp
      LogoutTimestamp
      LinkedSessionID
      __typename
    }
  }
`;
export const logoutCognitoUserv2 = /* GraphQL */ `
  mutation LogoutCognitoUserv2 {
    logoutCognitoUserv2 {
      SessionID
      CognitoUsername
      LoginTimestamp
      LogoutTimestamp
      LinkedSessionID
      __typename
    }
  }
`;
export const updateprofiledetails = /* GraphQL */ `
  mutation Updateprofiledetails(
    $CompanyName: String!
    $PhoneNumber: String!
    $EmailAddress: String!
  ) {
    updateprofiledetails(
      CompanyName: $CompanyName
      PhoneNumber: $PhoneNumber
      EmailAddress: $EmailAddress
    ) {
      CompanyName
      PhoneNumber
      EmailAddress
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createReceiptDetails = /* GraphQL */ `
  mutation CreateReceiptDetails(
    $createReceiptDetailsInput: CreateReceiptDetailsInput!
  ) {
    createReceiptDetails(
      createReceiptDetailsInput: $createReceiptDetailsInput
    ) {
      ID
      TransactionID
      CompanyID
      FinancialYearID
      LastUpdatedBy
      EnteredTimeStamp
      ExpiredTimeStamp
      TAN
      PartyName
      __typename
    }
  }
`;
export const createbusinessType = /* GraphQL */ `
  mutation CreatebusinessType($BusinessType: AWSJSON) {
    createbusinessType(BusinessType: $BusinessType) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatebusinessType = /* GraphQL */ `
  mutation UpdatebusinessType(
    $updatebusinessTypeInput: UpdatebusinessTypeInput!
  ) {
    updatebusinessType(updatebusinessTypeInput: $updatebusinessTypeInput) {
      BusinessTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      BusinessType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const createindustryType = /* GraphQL */ `
  mutation CreateindustryType($IndustryType: AWSJSON) {
    createindustryType(IndustryType: $IndustryType) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateindustryType = /* GraphQL */ `
  mutation UpdateindustryType(
    $updateindustryTypeInput: UpdateindustryTypeInput!
  ) {
    updateindustryType(updateindustryTypeInput: $updateindustryTypeInput) {
      IndustryTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      IndustryType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
  }
`;
export const freezeFinancialYear = /* GraphQL */ `
  mutation FreezeFinancialYear($FinancialYearID: Int!) {
    freezeFinancialYear(FinancialYearID: $FinancialYearID) {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const unFreezeFinancialYear = /* GraphQL */ `
  mutation UnFreezeFinancialYear($FinancialYearID: Int!) {
    unFreezeFinancialYear(FinancialYearID: $FinancialYearID) {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
  }
`;
export const createItemTablePreference = /* GraphQL */ `
  mutation CreateItemTablePreference(
    $createItemTablePreferenceInput: CreateItemTablePreferenceInput
  ) {
    createItemTablePreference(
      createItemTablePreferenceInput: $createItemTablePreferenceInput
    ) {
      ID
      CompanyID
      Type
      ItemCode
      ItemName
      Category
      Unit
      ShowItemIn
      PurchaseAC
      SalesAC
      HSNSAC
      Taxability
      PurchaseAmount
      SellingPrice
      UpdatePrice
      TotalSellingPrice
      EffectiveFrom
      EffectiveTo
      Actions
      UserID
      __typename
    }
  }
`;
export const createTransactionWithSpecificTime = /* GraphQL */ `
  mutation CreateTransactionWithSpecificTime(
    $TransactionMaster: AWSJSON!
    $TransactionDetails: AWSJSON!
    $TransactionRelation: AWSJSON!
    $TransactionAttachment: AWSJSON!
    $TransactionTCSDetails: AWSJSON!
    $TransactionTDSDetails: AWSJSON!
    $Mode: Int!
  ) {
    createTransactionWithSpecificTime(
      TransactionMaster: $TransactionMaster
      TransactionDetails: $TransactionDetails
      TransactionRelation: $TransactionRelation
      TransactionAttachment: $TransactionAttachment
      TransactionTCSDetails: $TransactionTCSDetails
      TransactionTDSDetails: $TransactionTDSDetails
      Mode: $Mode
    ) {
      TransactionID
      CompanyID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePaymentStatus = /* GraphQL */ `
  mutation UpdatePaymentStatus(
    $InvoiceType: String!
    $ID: Int!
    $PaymentStatus: Int!
  ) {
    updatePaymentStatus(
      InvoiceType: $InvoiceType
      ID: $ID
      PaymentStatus: $PaymentStatus
    ) {
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const generateOTP = /* GraphQL */ `
  mutation GenerateOTP($Purpose: String!, $OTPCode: Int!, $Active: Int) {
    generateOTP(Purpose: $Purpose, OTPCode: $OTPCode, Active: $Active) {
      ID
      Purpose
      OTPCode
      EnteredTimeStamp
      Active
      UserID
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const createItemLotDetails = /* GraphQL */ `
  mutation CreateItemLotDetails($ItemLotDetails: AWSJSON!) {
    createItemLotDetails(ItemLotDetails: $ItemLotDetails) {
      LotID
      ItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LotNumber
      LotQuantity
      ItemRate
      TypeCD
      Balance
      __typename
    }
  }
`;
export const createInvoiceAttachmentArray = /* GraphQL */ `
  mutation CreateInvoiceAttachmentArray($InvoiceAttachment: AWSJSON!) {
    createInvoiceAttachmentArray(InvoiceAttachment: $InvoiceAttachment) {
      InvoiceID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createPurchaseAttachmentArray = /* GraphQL */ `
  mutation CreatePurchaseAttachmentArray($PurchaseAttachment: AWSJSON!) {
    createPurchaseAttachmentArray(PurchaseAttachment: $PurchaseAttachment) {
      PurchaseID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createCrDrAttachmentArray = /* GraphQL */ `
  mutation CreateCrDrAttachmentArray($CrDrAttachment: AWSJSON!) {
    createCrDrAttachmentArray(CrDrAttachment: $CrDrAttachment) {
      CrDrNoteID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      UserID
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createTransactionAttachmentArray = /* GraphQL */ `
  mutation CreateTransactionAttachmentArray($TransactionAttachment: AWSJSON!) {
    createTransactionAttachmentArray(
      TransactionAttachment: $TransactionAttachment
    ) {
      TransactionID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AttachmentName
      AttachmentURL
      LastUpdatedBy
      DocumentName
      StatusCode
      StatusMessage
      Type
      __typename
    }
  }
`;
export const createItemAttachmentArray = /* GraphQL */ `
  mutation CreateItemAttachmentArray($ItemAttachment: AWSJSON!) {
    createItemAttachmentArray(ItemAttachment: $ItemAttachment) {
      ItemID
      AttachmentID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      LastUpdatedBy
      StatusCode
      StatusMessage
      DocumentName
      Type
      __typename
    }
  }
`;
export const createPriceType = /* GraphQL */ `
  mutation CreatePriceType($PriceType: AWSJSON) {
    createPriceType(PriceType: $PriceType) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PriceType
      UserID
      Is_Default
      Is_Active
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updatePriceType = /* GraphQL */ `
  mutation UpdatePriceType($updatepriceTypeInput: UpdatepriceTypeInput!) {
    updatePriceType(updatepriceTypeInput: $updatepriceTypeInput) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PriceType
      UserID
      Is_Default
      Is_Active
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateEInvoiceData = /* GraphQL */ `
  mutation UpdateEInvoiceData($updateEInvoiceData: UpdateEInvoiceDataInput!) {
    updateEInvoiceData(updateEInvoiceData: $updateEInvoiceData) {
      InvoiceID
      CompanyID
      AckNo
      AckDt
      Irn
      SignedQRCode
      Distance
      TransMode
      TransID
      TransName
      TrnDocDt
      TrnDocNo
      VehNo
      VehType
      __typename
    }
  }
`;
export const createEInvoiceMaster = /* GraphQL */ `
  mutation CreateEInvoiceMaster(
    $createEInvoiceMasterInput: CreateEInvoiceMasterInput!
  ) {
    createEInvoiceMaster(
      createEInvoiceMasterInput: $createEInvoiceMasterInput
    ) {
      ID
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AckNo
      AckDt
      Irn
      SignedQRCode
      UserID
      is_cancelled
      __typename
    }
  }
`;
export const deletePriceTypeDropdown = /* GraphQL */ `
  mutation DeletePriceTypeDropdown($PriceTypeID: Int!) {
    deletePriceTypeDropdown(PriceTypeID: $PriceTypeID) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PriceType
      UserID
      Is_Default
      Is_Active
      StatusCode
      StatusMessage
      __typename
    }
  }
`;
export const updateEInvoiceMaster = /* GraphQL */ `
  mutation UpdateEInvoiceMaster(
    $updateEInvoiceMasterInput: UpdateEInvoiceMasterInput!
  ) {
    updateEInvoiceMaster(
      updateEInvoiceMasterInput: $updateEInvoiceMasterInput
    ) {
      ID
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AckNo
      AckDt
      Irn
      SignedQRCode
      UserID
      is_cancelled
      __typename
    }
  }
`;
export const createuserinfopostgres = /* GraphQL */ `
  mutation Createuserinfopostgres($FirstName: String, $LastName: String) {
    createuserinfopostgres(FirstName: $FirstName, LastName: $LastName) {
      id
      userid
      enteredtimestamp
      expiredtimestamp
      firstname
      middlename
      lastname
      email
      phonenumber
      lastupdatedby
      statuscode
      statusmessage
      __typename
    }
  }
`;
export const createTodo = /* GraphQL */ `
  mutation CreateTodo(
    $input: CreateTodoInput!
    $condition: ModelTodoConditionInput
  ) {
    createTodo(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTodo = /* GraphQL */ `
  mutation UpdateTodo(
    $input: UpdateTodoInput!
    $condition: ModelTodoConditionInput
  ) {
    updateTodo(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTodo = /* GraphQL */ `
  mutation DeleteTodo(
    $input: DeleteTodoInput!
    $condition: ModelTodoConditionInput
  ) {
    deleteTodo(input: $input, condition: $condition) {
      id
      name
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
